import React, { useState, useEffect, useRef, useContext } from 'react'

import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import {
    PlanPosition,
    PlanPositionStage,
    Attachment,
    PlanCompliance,
    PlanComplianceData,
} from './types'
import { Plan } from '../types'
import { useAuth } from '../../../../hooks/auth'
import { Structure } from '../../Org/Structure/types'
import { OrganizationInfo } from '../../Org/Home/types'

import Checkbox from '../../../../components/form/Checkbox'

// import './style.css'

// import '../../../../components/Toolbar/Icon.css'
import PlanPositionsHeader from './components/Header'
import PlanPositionsTabs from './components/Tabs'
import PlanPositionsTableRow from './components/TableRow'
import LoadingIcon from '../../../../components/LoadingIcon'
import TableStageToolbarButtons from './components/Buttons/TableStageToolbarButtons'
import TableStageToolbarAdminButtons from './components/Buttons/TableStageToolbarAdminButtons'
import TableStageToolbarDownButtons from './components/Buttons/TableStageToolbarDownButton'
import TableRightClickButton from './components/Buttons/TableRightClickButton'

import TableHeaderDraft from './components/TableHeader/TableHeaderDraft'
import TableHeader from './components/TableHeader/TableHeader'

import {
    UserFilter,
    FilterSetting,
    Criteria,
} from './components/TableHeader/FilterTypes'

import FileUploaderBlock from './components/FileUploaderBlock'
import { Slide, ToastContainer } from 'react-toastify'

import { ThemeContext } from '../../../../components/ThemeContext'

import { CurrencyList } from '../Positions/Edit/types'
import HoverTooltip from '../../../../components/HoverTooltip'

interface ToEisSendInfo {
    modification_description: string
    additional_info: string
    approve_date: string
}

interface TakePlanFromEis {
    plan_guid: string
    registration_number: string
}

type ApiResponse = {
    message: Plan[]
}

type ApiResponseRoleGuid = {
    result: QueryItem[]
}

type QueryItem = {
    guid: string
    name: string
    organization_guid: string
    created_at: string
    updated_at: string
}

const getCurrentDate = (): string => {
    const today = new Date()
    const year = today.getFullYear()
    const month = String(today.getMonth() + 1).padStart(2, '0') // добавляем 1, так как месяцы начинаются с 0
    const day = String(today.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}

const getStructureList = async (): Promise<Structure[]> => {
    return fetch(
        process.env.REACT_APP_API_URL + '/api/backend/v1/organization_struct',
        {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        }
    )
        .then((response) => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error('Ошибка запроса на способы закупок')
            }
        })
        .catch((e) => {
            console.error(e)
        })
}

const getCurrencyList = async (): Promise<CurrencyList[]> => {
    return fetch(process.env.REACT_APP_API_URL + '/api/backend/v1/currency', {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then((response) => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error('Ошибка запроса на курсы валют')
            }
        })
        .catch((e) => {
            console.error(e)
        })
}

const getRole = async (role_guid: string): Promise<QueryItem> => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/api/backend/v1/organizations/roles_by_guid/${role_guid}`,
            {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        )

        if (!response.ok) {
            throw new Error('Ошибка запроса на роль')
        }

        const data: ApiResponseRoleGuid = await response.json()
        // Извлекаем первый элемент массива, т.к. он всегда содержит единственный объект
        return data.result[0]
    } catch (error) {
        console.error('Ошибка:', error)
        // Возвращаем объект по умолчанию, соответствующий типу QueryItem
        return {
            guid: '',
            name: '',
            organization_guid: '',
            created_at: '',
            updated_at: '',
        }
    }
}

// Отдельная функция для проверки, есть ли скролл
const checkScroll = (element: HTMLElement | null): boolean => {
    ;``
    return element ? element.scrollHeight > element.clientHeight : false
}

const PlanPositionListPage: React.FC = () => {
    const navigate = useNavigate()
    const { plan_reg_number: reg_number } = useParams()
    // const [planGuidNav, setPlanGuidNav] = useState(reg_number)

    const { theme } = useContext(ThemeContext)

    const [planVersionDiff, setPlanVersionDiff] = useState('')
    const [planCompliance, setPlanCompliance] =
        useState<PlanCompliance | null>()

    const [planVersion, setPlanVersion] = useState<string | null>('Нет данных')

    const { user } = useAuth()

    const [orgData, setOrgData] = useState<OrganizationInfo>()

    const [filter, setFilter] = useState<UserFilter | null>(null)
    // Дополнительное состояние
    const [filterLoaded, setFilterLoaded] = useState(false)

    const [structureList, setStructureList] = useState<Structure[]>([])
    const [currencyList, setCurrencyList] = useState<CurrencyList[]>([])

    const [isUserRoleName, setUserRoleName] = useState('')

    const [searchParams] = useSearchParams()
    const initialStage = searchParams.get('stage') as PlanPositionStage

    const [stage, setStage] = useState<PlanPositionStage>(
        initialStage || PlanPositionStage.EDIT
    )

    const [editStage, setEditStage] = useState(null)
    const [readyStage, setReadyStage] = useState(null)
    const [sentStage, setSentStage] = useState(null)

    const [countPlan, setCountPlan] = useState('Нет данных')
    const [sumPlan, setSumPlan] = useState('Нет данных')
    const [sumMSPPlanPercent, setSumMSPPlanPercent] = useState(0)
    const [sumMSPPlan, setSumMSPPlan] = useState(0)

    const [isLoadingPlan, setLoadingPlan] = useState<boolean>(true)
    const [plan, setPlan] = useState<Plan[]>([])
    const [isSendPlan, setSendPlan] = useState<boolean>(false)

    const [isLoading, setLoading] = useState<boolean>(false)
    const [isLoadingPosition, setLoadingPosition] = useState<boolean>(false)
    const [items, setItems] = useState<PlanPosition[]>([])
    const [page, setPage] = useState(1) // -1 - no more data

    const [selectedItems, setSelectedItems] = useState<string[]>([])
    const [selectAll, setSelectAll] = useState<boolean>(false)

    const [changePlanPositionPopup, setChangePlanPositionPopup] =
        useState<boolean>(false)
    const [isCreating, setCreating] = useState<boolean>(false)
    const [changeItems, setChangeItems] = useState<PlanPosition[]>([])
    const [changeStatusItems, setChangeStatusItems] = useState('')

    const [deletePlanPositionPopup, setDeletePlanPositionPopup] =
        useState<boolean>(false)
    const [isDeleting, setDeleting] = useState<boolean>(false)
    const [deleteItems, setDeleteItems] = useState<PlanPosition[]>([])

    const [copyPlanPositionPopup, setCopyPlanPositionPopup] =
        useState<boolean>(false)
    const [isCopying, setCopying] = useState<boolean>(false)
    const [copyItems, setCopyItems] = useState<PlanPosition[]>([])

    const [copyPlanPositionDraftPopup, setCopyPlanPositionDraftPopup] =
        useState<boolean>(false)

    const [annulatePlanPositionPopup, setAnnulatePlanPositionPopup] =
        useState<boolean>(false)
    const [isAnnulating, setAnnulating] = useState<boolean>(false)
    const [annulateItems, setAnnulateItems] = useState<PlanPosition[]>([])
    const [canAnnulate, setCanAnnulate] = useState<boolean>(false)
    const [canDeletePosition, setCanDeletePosition] = useState<boolean>(false)
    const [canMoveReadyToSent, setCanMoveReadyToSent] = useState<boolean>(false)
    const [canMoveBackToEdit, setCanMoveBackToEdit] = useState<boolean>(false)
    const [canMoveReadyToEis, setCanMoveReadyToEis] = useState<boolean>(false)
    const [annulateReason, setAnnulateReason] = useState('REJECT')

    const [statusChangePlanPositionPopup, setStatusChangePlanPositionPopup] =
        useState<boolean>(false)
    const [isStatusChanging, setStatusChanging] = useState<boolean>(false)
    const [statusChangeItems, setStatusChangeItems] = useState<PlanPosition[]>(
        []
    )
    const [statusChangeFlag, setStatusChangeFlag] = useState('')

    const [stageChangePlanPositionPopup, setStageChangePlanPositionPopup] =
        useState<boolean>(false)
    const [isStageChanging, setStageChanging] = useState<boolean>(false)
    const [stageChangeItems, setStageChangeItems] = useState<PlanPosition[]>([])
    const [stageChangeFlag, setStageChangeFlag] = useState('')

    const [toEisSendPopup, setToEisSendPopup] = useState<boolean>(false)
    const [isToEisSending, setToEisSending] = useState<boolean>(false)
    const [toEisSendInfo, setToEisSendInfo] = useState<ToEisSendInfo>({
        modification_description: '',
        additional_info: '',
        approve_date: getCurrentDate(), // текущая дата
    })
    const [toEisSendResponsePopup, setToEisSendResponsePopup] =
        useState<boolean>(false)
    const [toEisSendResponse, setToEisSendResponse] = useState<any | null>(null)

    const [updateFromEisPopup, setUpdateFromEisPopup] = useState<boolean>(false)
    const [isUpdatingFromEis, setUpdatingFromEis] = useState<boolean>(false)
    const [popupMessage, setPopupMessage] = useState('')
    const [forceUpdateUrl, setForceUpdateUrl] = useState<string | null>(null)

    const [takeFromEisPopup, setTakeFromEisPopup] = useState<boolean>(false)
    const [isTakingFromEis, setTakingFromEis] = useState<boolean>(false)
    const [takePlanFromEisInfo, setTakePlanFromEisInfo] =
        useState<TakePlanFromEis>({
            plan_guid: '',
            registration_number: '',
        })

    const [menuVisible, setMenuVisible] = useState(false)
    const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 })

    const [isPrinting, setPrinting] = useState(false) // Есть ли еще данные для загрузки

    const [importPlanPositionPopup, setImportPlanPositionPopup] =
        useState<boolean>(false)
    const [isImporting, setImporting] = useState<boolean>(false)
    const [selectedFile, setSelectedFile] = useState<File | null>(null) // Храним выбранный файл
    const [uploadMessage, setUploadMessage] = useState<string | null>(null) // Сообщение о результате загрузки

    const [isExporting, setExporting] = useState<boolean>(false)

    //  проверка скрол есть или нет
    const scrollRef = useRef<HTMLDivElement>(null)
    const [hasScroll, setHasScroll] = useState(false)

    const [isAttachment, setAttachment] = useState(false)
    const [publishedAttachmentItems, setPublishedAttachmentItems] = useState<
        Attachment[]
    >([])

    const positionsAbortControllerRef = useRef<AbortController | null>(null)
    const positionsRequestIdRef = useRef(0)

    const [addContractPopup, setAddContractPopup] = useState<boolean>(false)

    const loadOrganizationData = async (): Promise<OrganizationInfo> => {
        return fetch(
            process.env.REACT_APP_API_URL + '/api/backend/v1/organization',
            {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        )
            .then((response) => {
                if (response.ok) {
                    return response.json()
                } else {
                    throw new Error('Failed to fetch organization')
                }
            })
            .catch((e) => {
                console.error(e)
            })
    }

    // Функция для получения размещенных прикрепленных файлов
    const getPublishedAttachment = async (): Promise<Attachment[]> => {
        return fetch(
            process.env.REACT_APP_API_URL +
                `/api/backend/v2/attachments?reg_number=${reg_number}`,
            {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        )
            .then((response) => {
                if (response.ok) {
                    return response.json()
                } else {
                    throw new Error('Ошибка запроса на фильтры пользователя')
                }
            })
            .catch((error) => {
                console.error(error)
                throw error
            })
    }

    // Функция для получения фильтров пользователя
    const getUserFilters = async (): Promise<UserFilter[]> => {
        return fetch(
            process.env.REACT_APP_API_URL + '/api/backend/v1/user_filter',
            {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        )
            .then((response) => {
                if (response.ok) {
                    return response.json()
                } else {
                    throw new Error('Ошибка запроса на фильтры пользователя')
                }
            })
            .catch((error) => {
                console.error(error)
                throw error
            })
    }

    // Функция для получения фильтров пользователя
    const getUserFilterTypeCategory = async (
        user_guid: string,
        filter_type: string,
        filter_category: string
    ): Promise<UserFilter> => {
        return fetch(
            process.env.REACT_APP_API_URL +
                `/api/backend/v1/user_and_filtertype?user_guid=${user_guid}&filter_type=${filter_type}&filter_category=${filter_category}`,
            {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        )
            .then((response) => {
                if (response.ok) {
                    return response.json()
                } else {
                    throw new Error('Ошибка запроса на фильтр пользователя')
                }
            })
            .then((data) => {
                // Если данные представляют собой массив, возвращаем первую позицию (либо null, если массив пуст)
                if (Array.isArray(data) && data.length > 0) {
                    return data[0]
                } else {
                    return null
                }
            })
            .catch((error) => {
                console.error(error)
                throw error
            })
    }

    // Функция для обновления фильтра пользователя по PUT-запросу
    const updateUserFilter = async (
        filterData: {
            filter_type: string
            filter_settings: FilterSetting
            filter_category: string
        },
        guid: string
    ): Promise<UserFilter> => {
        return fetch(
            `${process.env.REACT_APP_API_URL}/api/backend/v1/user_filter/${guid}`,
            {
                method: 'PUT',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    accept: 'application/json',
                },
                body: JSON.stringify(filterData),
            }
        )
            .then((response) => {
                if (response.ok) {
                    return response.json()
                } else {
                    throw new Error(
                        'Ошибка запроса на обновление фильтра пользователя'
                    )
                }
            })
            .catch((error) => {
                console.error(error)
                throw error
            })
    }

    const createUserFilter = async (filterData: {
        filter_type: string
        filter_settings: { criteria: Criteria | null; filter_enabled: boolean }
        filter_category: string
    }): Promise<UserFilter> => {
        return fetch(
            process.env.REACT_APP_API_URL + '/api/backend/v1/user_filter',
            {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    accept: 'application/json',
                },
                body: JSON.stringify(filterData),
            }
        )
            .then((response) => {
                if (response.ok) {
                    return response.json()
                } else {
                    throw new Error('Ошибка создания фильтра пользователя')
                }
            })
            .catch((error) => {
                console.error(error)
                throw error
            })
    }

    const loadPlan = () => {
        setLoadingPlan(true)

        fetch(process.env.REACT_APP_API_URL + '/api/backend/v2/plans', {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                if (response.ok) {
                    return response.json()
                } else {
                    throw new Error('Failed to fetch plan')
                }
            })
            .then((response: ApiResponse) => response.message)
            .catch((e) => {
                console.error(e)
                return []
            })
            .then((response) => {
                setPlan(
                    response.filter(
                        (plans: Plan) =>
                            String(plans.registration_number) === reg_number
                    )
                )

                const planData = response.filter(
                    (plans: Plan) =>
                        String(plans.registration_number) === reg_number
                )
                planData.map((item) => {
                    setSendPlan(item.is_sent)
                    setPlanVersion(item.version ? item.version : null)
                })
            })
            .finally(() => {
                setLoadingPlan(false)
            })
    }

    const loadPlanPositions = (
        page_num = 1,
        userFilter: UserFilter | null = null,
        stageSnapshot: PlanPositionStage = stage
    ) => {
        // Отменяем предыдущий запрос только при загрузке первой страницы.
        // Для бесконечного скролла page > 1 лучше не отменять предыдущую страницу,
        // если это не требуется.
        if (page_num === 1) {
            positionsAbortControllerRef.current?.abort()
            setPage(1)
            setItems([])
        }

        const controller = new AbortController()
        positionsAbortControllerRef.current = controller

        const requestId = ++positionsRequestIdRef.current

        setLoadingPosition(true)

        const pageSize = 100

        const postfix =
            stageSnapshot === PlanPositionStage.PURCHASE_PLAN_IN_EIS
                ? 'plan_positions_with_approval_and_user'
                : 'plan_positions_draft_with_approval_and_user'

        const stage_query = stageSnapshot ? '&stage=' + stageSnapshot : ''

        let url =
            `${process.env.REACT_APP_API_URL}/api/backend/v2/${postfix}/` +
            `?reg_number=${encodeURIComponent(reg_number as string)}${stage_query}` +
            `&page=${page_num}&size=${pageSize}`

        if (userFilter?.filter_settings?.filter_enabled) {
            url += `&filter_settings=${encodeURIComponent(
                JSON.stringify(userFilter.filter_settings)
            )}`
        }

        fetch(url, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            signal: controller.signal,
        })
            .then((response) => {
                if (response.ok) {
                    return response.json()
                }

                throw new Error(
                    'Failed to fetch plan positions (page: ' + page_num + ')'
                )
            })
            .then((data) => {
                // Если это уже не последний актуальный запрос — ничего не делаем
                if (requestId !== positionsRequestIdRef.current) return

                // Если запрос отменен — ничего не делаем
                if (controller.signal.aborted) return

                const filteredData = data.filter(
                    (item: PlanPosition) =>
                        item.position_stage === stageSnapshot
                )

                if (page_num === 1) {
                    setItems(filteredData)
                } else {
                    setItems((prev) => [...prev, ...filteredData])
                }

                setPage(data.length < pageSize ? -1 : page_num + 1)
            })
            .catch((e) => {
                if (e.name === 'AbortError') {
                    return
                }

                console.error(e)

                if (requestId === positionsRequestIdRef.current) {
                    if (page_num === 1) {
                        setItems([])
                    }
                    setPage(-1)
                }
                setLoadingPosition(false)
            })
            .finally(() => {
                if (requestId === positionsRequestIdRef.current) {
                    setLoadingPosition(false)
                }
            })
    }

    const fetchAllPositions = async (): Promise<PlanPosition[]> => {
        const pageSize = 100 // Размер страницы
        const postfix =
            stage === PlanPositionStage.PURCHASE_PLAN_IN_EIS ? '' : '_draft'
        let allItems: PlanPosition[] = []
        let currentPage = 1

        while (true) {
            try {
                const response = await fetch(
                    process.env.REACT_APP_API_URL +
                        `/api/backend/v2/plan_positions${postfix}/?reg_number=${encodeURIComponent(
                            reg_number as string
                        )}&page=${currentPage}&size=${pageSize}`,
                    {
                        method: 'GET',
                        credentials: 'include',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    }
                )

                if (!response.ok) {
                    throw new Error(
                        `Failed to fetch plan positions (page: ${currentPage})`
                    )
                }

                const data: PlanPosition[] = await response.json()

                // Фильтруем данные по stage
                const filteredData = data.filter(
                    (item: PlanPosition) => item.position_stage === stage
                )

                // Добавляем данные в массив
                allItems = [...allItems, ...filteredData]

                // Если получено меньше позиций, чем размер страницы — завершаем
                if (filteredData.length < pageSize) {
                    break
                }

                currentPage++
            } catch (error) {
                console.error(error)
                break
            }
        }

        return allItems
    }

    const positionDraftGuid = async (guid: string): Promise<PlanPosition> => {
        return fetch(
            process.env.REACT_APP_API_URL +
                `/api/backend/v2/plan_position_draft/?reg_number=${encodeURIComponent(
                    reg_number as string
                )}&guid=${guid}`,
            {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        )
            .then(async (response) => {
                if (response.ok) {
                    return await response.json()
                } else {
                    throw new Error('Ошибка запроса на роли')
                }
            })
            .catch((e) => {
                console.error('Ошибка:', e)
                return ''
            })
    }

    const loadPositionDraftCountStage = () => {
        setLoading(true)

        fetch(
            process.env.REACT_APP_API_URL +
                `/api/backend/v2/plan_positions_draft_count_stage?reg_number=${reg_number}`,
            {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        )
            .then((response) => {
                if (response.ok) {
                    return response.json()
                } else {
                    throw new Error('Failed to fetch count')
                }
            })
            .then((data) => {
                // Обновляем состояния
                setEditStage(data.edit_count || 0)
                setReadyStage(data.ready_count || 0)
                setSentStage(data.sent_count || 0)
            })
            .catch((e) => {
                console.error(e)
                // Устанавливаем значения по умолчанию на случай ошибки
                setEditStage(null)
                setReadyStage(null)
                setSentStage(null)
                setLoading(false)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const loadCountPlan = async () => {
        setLoading(true)

        try {
            const response = await fetch(
                process.env.REACT_APP_API_URL +
                    `/api/backend/v2/plan_positions_count_without_draft/?reg_number=${reg_number}`,
                {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            if (!response.ok) {
                setCountPlan('Нет данных')
                setLoading(false)
                throw new Error(`Error: ${response.statusText}`)
            }

            const poses_count = await response.json()

            setCountPlan(poses_count.poses_count)
        } catch (error) {
            console.error('Error fetching data:', error)
        } finally {
            setLoading(false)
        }
    }

    const loadSumPlan = async () => {
        setLoading(true)

        try {
            const response = await fetch(
                process.env.REACT_APP_API_URL +
                    `/api/backend/v2/plan_positions_summ_piechartplansumm/?reg_number=${reg_number}`,
                {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            if (!response.ok) {
                setSumPlan('Нет данных')
                setLoading(false)
                throw new Error(`Error: ${response.statusText}`)
            }

            const poses_summ = await response.json()

            setSumPlan(poses_summ.poses_summ)
        } catch (error) {
            console.error('Error fetching data:', error)
        } finally {
            setLoading(false)
        }
    }

    const loadSumMSPPlan = async () => {
        setLoading(true)

        try {
            const response = await fetch(
                process.env.REACT_APP_API_URL +
                    `/api/backend/v2/plan_positions_count_piechartplansummsmb/?reg_number=${reg_number}`,
                {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            if (!response.ok) {
                setSumMSPPlan(0)
                setSumMSPPlanPercent(0)
                setLoading(false)
                throw new Error(`Error: ${response.statusText}`)
            }

            const poses_sum = await response.json()

            // Проверяем, что все необходимые поля существуют
            if (
                typeof poses_sum.poses_sum_smb === 'undefined' ||
                typeof poses_sum.poses_sum_not_smb === 'undefined'
            ) {
                setSumMSPPlan(0)
                setSumMSPPlanPercent(0)
                // throw new Error('Response does not contain required fields')
            }

            // Проверяем деление на ноль
            if (poses_sum.poses_sum_smb === 0) {
                setSumMSPPlan(0)
                // throw new Error('Division by zero error')
            }

            // Расчёт процента
            const calc =
                (poses_sum.poses_sum_smb * 100) /
                (poses_sum.poses_sum_smb + poses_sum.poses_sum_not_smb)

            setSumMSPPlan(poses_sum.poses_sum_smb)
            setSumMSPPlanPercent(Number(calc.toFixed(2)))
        } catch (error) {
            console.error('Error fetching data:', error)
        } finally {
            setLoading(false)
        }
    }

    const deletePosition = async (guid: string): Promise<void> => {
        const url =
            process.env.REACT_APP_API_URL +
            `/api/backend/v2/plan_position_draft/?reg_number=${reg_number}&guid=${guid}`

        try {
            const response = await fetch(url, {
                method: 'DELETE',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            })

            if (!response.ok) {
                throw new Error(
                    `Failed to delete position. Status: ${response.status}`
                )
            }

            console.log('Position deleted successfully')
        } catch (error) {
            console.error('Error while deleting position:', error)
            setDeleting(false)
        } finally {
        }
    }

    const changePosition = async (guid: string): Promise<void> => {
        const url =
            process.env.REACT_APP_API_URL +
            `/api/backend/v2/plan_position_draft_from/?reg_number=${reg_number}&from_guid=${guid}`

        try {
            const response = await fetch(url, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            })

            if (!response.ok) {
                throw new Error(
                    `Failed to create new position from. Status: ${response.status}`
                )
            }

            if (response.ok) {
                const responseData = await response.json()

                // Обработка успешного ответа
                const newGuid = responseData.plan_pos?.guid

                if (newGuid) {
                    navigate(
                        `/hub/plans/${reg_number}/positions/draft/${newGuid}`
                    )
                    setChangePlanPositionPopup(false)
                }
            }

            console.log('Position created successfully')
        } catch (error) {
            console.error('Error while creating position:', error)
            setCreating(false)
        } finally {
        }
    }

    const copyPosition = async (guid: string): Promise<void> => {
        const url =
            process.env.REACT_APP_API_URL +
            `/api/backend/v2/plan_position_draft_new_from/?reg_number=${reg_number}&from_guid=${guid}`

        try {
            const response = await fetch(url, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            })

            if (!response.ok) {
                throw new Error(
                    `Failed to create new position from. Status: ${response.status}`
                )
            }

            console.log('Position created successfully')
        } catch (error) {
            console.error('Error while creating position:', error)
            setCopying(false)
        } finally {
        }
    }

    const copyPositionDraft = async (guid: string): Promise<void> => {
        const url =
            process.env.REACT_APP_API_URL +
            `/api/backend/v2/plan_position_draft_from_draft/?reg_number=${reg_number}&from_guid=${guid}`

        try {
            const response = await fetch(url, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            })

            if (!response.ok) {
                throw new Error(
                    `Failed to create new position from. Status: ${response.status}`
                )
            }

            console.log('Position created successfully')
        } catch (error) {
            console.error('Error while creating position:', error)
            setCopying(false)
        } finally {
        }
    }

    const annulatePosition = async (
        guid: string,
        cancellationReason: string
    ): Promise<void> => {
        const url =
            process.env.REACT_APP_API_URL +
            `/api/backend/v2/plan_position_draft_annulate/?reg_number=${reg_number}&guid=${guid}&cancellation_reason=${cancellationReason}`

        try {
            const response = await fetch(url, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            })

            if (!response.ok) {
                throw new Error(
                    `Failed to annulate position from. Status: ${response.status}`
                )
            }

            console.log('Position annulate successfully')
        } catch (error) {
            console.error('Error while annulating position:', error)
            setAnnulating(false)
        } finally {
        }
    }

    const statusChangePosition = async (
        guid: string,
        statusPos: string
    ): Promise<void> => {
        const url =
            process.env.REACT_APP_API_URL +
            `/api/backend/v2/plan_positions_draft_change_status/?reg_number=${reg_number}&pos_guid=${guid}`

        try {
            const response = await fetch(url, {
                method: 'PUT',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ position_status: statusPos }),
            })

            if (!response.ok) {
                throw new Error(
                    `Failed to change status position from. Status: ${response.status}`
                )
            }

            console.log('Position status change successfully')
        } catch (error) {
            console.error('Error while changing status position:', error)
            setStatusChanging(false)
        } finally {
        }
    }

    const stageChangePosition = async (
        guid: string,
        stagePos: string
    ): Promise<void> => {
        const url =
            process.env.REACT_APP_API_URL +
            `/api/backend/v2/plan_positions_draft_change_stage/?reg_number=${reg_number}&pos_guid=${guid}`

        try {
            const response = await fetch(url, {
                method: 'PUT',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ position_stage: stagePos }),
            })

            if (!response.ok) {
                throw new Error(
                    `Failed to change stage position from. Status: ${response.status}`
                )
            }

            console.log('Position stage change successfully')
        } catch (error) {
            console.error('Error while changing stage position:', error)
            setStageChanging(false)
        } finally {
        }
    }

    // Пример асинхронной функции для парсинга ответа от toEisSendPlan
    const parseEisSendResponse = async (response: any): Promise<string> => {
        // Получаем значение body из новой или старой вложенной структуры ответа
        const body =
            response?.message?.text?.body ?? response?.message?.text?.text?.body

        // Получаем значение result из вложенной структуры ответа
        const result = body?.result

        if (result === 'success') {
            return 'Всё прошло успешно'
        } else if (result === 'failure') {
            const violations = body?.violations?.violation
            const errorDescriptions: string[] = []

            // Регулярное выражение для поиска GUID (регистр не важен)
            const guidRegex =
                /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi

            // Функция для обработки одного объекта нарушения
            const processViolation = async (v: any) => {
                if (v.level === 'error' && v.description) {
                    // Ищем GUID в тексте ошибки
                    const guidMatches = v.description.match(guidRegex)

                    if (guidMatches && guidMatches.length > 0) {
                        // Если найдено несколько GUID – для каждого формируем отдельное сообщение
                        for (const guid of guidMatches) {
                            try {
                                // Вызываем функцию для получения данных по позиции
                                const positionData =
                                    await positionDraftGuid(guid)
                                const contractSubject =
                                    positionData.contract_subject
                                // Убираем GUID из исходного текста (чтобы не дублировать его)
                                const cleanedDescription = v.description
                                    .replace(guid, '')
                                    .trim()
                                // Формируем сообщение согласно требуемому формату
                                const formattedError = `Позиция: ${contractSubject}\nПо позиции ${guid} ${cleanedDescription}`
                                errorDescriptions.push(formattedError)
                            } catch (err) {
                                console.error(
                                    'Ошибка при получении данных позиции для GUID:',
                                    guid,
                                    err
                                )
                                // Если ошибка при запросе, добавляем исходное описание
                                errorDescriptions.push(v.description)
                            }
                        }
                    } else {
                        // Если GUID не найден, просто добавляем исходное описание ошибки
                        errorDescriptions.push(v.description)
                    }
                }
            }

            // Если violations – это массив, обрабатываем каждый элемент
            if (Array.isArray(violations)) {
                for (const violation of violations) {
                    await processViolation(violation)
                }
            } else if (violations && violations.level === 'error') {
                // Если violation – это одиночный объект
                await processViolation(violations)
            }

            return errorDescriptions.join('\n\n')
        }

        // Обработка ошибок, которые вернул бэк через detail
        const detail = response?.detail

        if (detail) {
            // Если detail строка
            if (typeof detail === 'string') {
                return detail
            }

            // Если detail объект
            if (typeof detail === 'object') {
                const error = detail?.error
                const statusCode = detail?.status_code
                const detailText = detail?.detail

                if (statusCode === 502) {
                    return 'Ошибка при отправке плана в ЕИС:\n- Сервис интеграции ЕИС не отвечает.\n Пожалуйста, повторите попытку через 30 минут.'
                }

                if (statusCode === 503) {
                    return 'Ошибка при отправке плана в ЕИС:\n- Сервис интеграции ЕИС не отвечает.\n Пожалуйста, повторите попытку через 30 минут.'
                }

                if (statusCode === 504) {
                    return 'Ошибка при отправке плана в ЕИС:\n- Сервис интеграции ЕИС не ответил вовремя.\n Пожалуйста, повторите попытку.'
                }

                if (statusCode && detailText) {
                    return `Ошибка при отправке плана в ЕИС:\n- ${statusCode}: ${detailText}`
                }

                if (detailText) {
                    return `Ошибка при отправке плана в ЕИС:\n- ${detailText}`
                }

                if (error) {
                    return `Ошибка при отправке плана в ЕИС:\n- ${error}`
                }
            }
        }

        return 'Неизвестный формат ответа'
    }

    const toEisSendPlan = async (send_info: ToEisSendInfo): Promise<void> => {
        const url =
            process.env.REACT_APP_API_URL +
            `/api/backend/v2/plan_to_eis?reg_number=${reg_number}`

        try {
            const response = await fetch(url, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(send_info),
            })

            let responseData: any = null

            try {
                responseData = await response.json()
            } catch (e) {
                responseData = null
            }

            if (!response.ok) {
                const parsedError = responseData
                    ? await parseEisSendResponse(responseData)
                    : `Ошибка при отправке плана в ЕИС:\n- HTTP ${response.status}`

                setToEisSendResponse(parsedError)
                setToEisSendResponsePopup(true)
                return
            }

            const parsedResponse = await parseEisSendResponse(responseData)

            setToEisSendResponse(parsedResponse)
            setToEisSendResponsePopup(true)
        } catch (error) {
            console.error('Error while sending plan to EIS:', error)
            setToEisSendResponse(
                `Ошибка при отправке плана в ЕИС:\n- ${String(error)}`
            )
            setToEisSendResponsePopup(true)
        } finally {
            loadPlan()
        }
    }

    const updatePlanFromEis = async (): Promise<void> => {
        const url =
            process.env.REACT_APP_API_URL + `/api/backend/v2/plan_from_eis`
        setUpdatingFromEis(true)

        try {
            const response = await fetch(url, {
                method: 'PUT',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ reg_number: reg_number }),
            })

            if (response.ok) {
                const responseData = await response.json()

                // Обработка ошибки одинаковых весрий
                if (
                    responseData.details &&
                    responseData.details.includes('version')
                ) {
                    setPopupMessage(
                        'Версии плана закупки в системе и в ЕИС совпадают. Вы уверены, что хотите выполнить обновление?'
                    )
                    setForceUpdateUrl(
                        process.env.REACT_APP_API_URL +
                            `/api/backend/v2/plan_from_eis?force_update=true`
                    )
                    setUpdateFromEisPopup(true)
                    return
                }

                // Обработка ошибки несовпадения данных
                if (
                    responseData.details &&
                    responseData.details.includes("'is_success': False")
                ) {
                    setPopupMessage(
                        'Данные из ЕИС отличаются от данных в системе. Хотите продолжить обновление?'
                    )
                    setForceUpdateUrl(
                        process.env.REACT_APP_API_URL +
                            `/api/backend/v2/plan_from_eis?force_update=true`
                    )
                    setUpdateFromEisPopup(true)
                    return
                }

                // Обработка c отличием ИНН
                if (
                    responseData.details &&
                    responseData.details.includes('ИНН')
                ) {
                    setPopupMessage(
                        'ИНН плана закупки не соответствует ИНН вашей организации'
                    )
                    return
                }

                // Обработка c отличием ИНН
                if (
                    responseData.details &&
                    responseData.details.includes('multiple plan')
                ) {
                    setPopupMessage('План закупки уже был добавлен в реестр')
                    return
                }

                // Обновите состояние
                navigate(
                    `/hub/plans/${reg_number}/positions?stage=План закупки в ЕИС`
                )
                loadPlan()
                loadPlanPositions(1, filter, stage)
                loadPositionDraftCountStage()
                loadCountPlan()
                loadSumPlan()
                loadSumMSPPlan()
                setTakeFromEisPopup(false)

                setPlanVersionDiff('')
                setPlanCompliance(null)
            }

            if (!response.ok) {
                let errorData
                try {
                    errorData = await response.json()
                } catch (e) {
                    console.error('Failed to parse JSON from response:', e)
                    throw new Error(
                        `Unexpected error: Unable to parse JSON. Status: ${response.status}`
                    )
                }
                // Если ошибка не подходит под указанные типы
                throw new Error(
                    `Failed to update plan from EIS. Status: ${response.status}, Message: ${errorData.message}`
                )
            }
        } catch (error) {
            console.error('Error while updating plan from EIS:', error)
            setPopupMessage('Ошибка связывания плана. Проверьте номер плана')
        } finally {
            setUpdatingFromEis(false) // Отключаем анимацию загрузки
            setTakingFromEis(false) // Отключаем анимацию загрузки
        }
    }

    const handleForceUpdate = async () => {
        if (!forceUpdateUrl) return // Если URL отсутствует, ничего не делаем

        setUpdatingFromEis(true)
        try {
            const response = await fetch(forceUpdateUrl, {
                method: 'PUT',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ reg_number: reg_number }), // Используйте правильное значение
            })

            if (!response.ok) {
                throw new Error(
                    `Failed to force update plan. Status: ${response.status}`
                )
            }

            const data = await response.json()
            const newGuid = data.plan?.new_guid

            if (newGuid) {
                // setPlanGuidNav(newGuid)
                navigate(
                    `/hub/plans/${reg_number}/positions?stage=План закупки в ЕИС`
                )
                loadPlan()
                loadPlanPositions(1, filter, stage)
                loadPositionDraftCountStage()
                loadCountPlan()
                loadSumPlan()
                loadSumMSPPlan()
                setTakeFromEisPopup(false)
            }
            setPlanVersionDiff('')
            setPlanCompliance(null)
        } catch (error) {
            console.error('Error while forcing update plan:', error)
        } finally {
            setUpdatingFromEis(false) // Закрыть Popup
            setUpdateFromEisPopup(false)
        }
    }

    const takePlanFromEis = async (takeInfo: TakePlanFromEis) => {
        setTakingFromEis(true) // Включаем анимацию загрузки
        try {
            const response = await fetch(
                process.env.REACT_APP_API_URL +
                    `/api/backend/v2/plans/update_registration_number`,
                {
                    method: 'PUT',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(takeInfo), // Добавлено тело запроса
                }
            )
            if (!response.ok) {
                throw new Error('Ошибка при добавлении плана')
            }
            updatePlanFromEis()
        } catch (error) {
            console.error('Ошибка при добавлении плана:', error)
        } finally {
            loadPlan()
        }
    }

    const checkPlanVersion = async () => {
        return fetch(
            process.env.REACT_APP_API_URL +
                `/api/backend/v2/plan_from_eis_check?reg_number=${reg_number}`,
            {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        )
            .then((response) => {
                if (response.ok) {
                    return response.json()
                } else {
                    throw new Error('Ошибка запроса проверки версии плана')
                }
            })
            .catch((e) => {
                console.error(e)
            })
    }

    useEffect(() => {
        loadPlan()
        const fetchData = async () => {
            const organization = await loadOrganizationData()
            if (organization) {
                setOrgData(organization)
            }

            const role = await getRole(user?.object.role_id)
            setUserRoleName(role.name)

            const structs = await getStructureList()
            if (structs) {
                setStructureList(structs) // Обновляем список структур
            }

            const currency = await getCurrencyList()
            if (currency) {
                setCurrencyList(currency) // Обновляем список структур
            }

            const attachments = await getPublishedAttachment()
            if (attachments) {
                setPublishedAttachmentItems(attachments) // Обновляем список файлов приложений
            }
        }
        fetchData()
    }, [])

    useEffect(() => {
        return () => {
            positionsAbortControllerRef.current?.abort()
        }
    }, [])

    useEffect(() => {
        const fetchData = async () => {
            if (isUserRoleName == 'specialist' || isUserRoleName == 'admin') {
                await checkPlanVersion()
                    .then((result) => {
                        if (result.plan_published) {
                            if (result && !result.plan_published.is_different) {
                                setPlanVersionDiff('')
                            } else {
                                setPlanVersionDiff(
                                    result.plan_published.data.version
                                )
                            }
                        }

                        if (result && result.plan_compliance) {
                            setPlanCompliance(result.plan_compliance)
                        } else {
                            setPlanCompliance(null)
                        }
                    })
                    .catch((error) => {
                        console.error('Ошибка получения данных:', error)
                    })
            }
        }
        if (isUserRoleName) fetchData()
    }, [isUserRoleName])

    // Проверка скролла
    useEffect(() => {
        const updateScrollState = () => {
            setHasScroll(checkScroll(scrollRef.current))
        }

        // Первоначальная проверка
        updateScrollState()

        // Перепроверяем при изменении размеров окна
        window.addEventListener('resize', updateScrollState)
        return () => window.removeEventListener('resize', updateScrollState)
    }, [items])

    // Инциализация load & on tab change
    useEffect(() => {
        setSelectedItems([])
        navigate(`/hub/plans/${reg_number}/positions?stage=${stage}`)

        if (
            (isUserRoleName == 'specialist' || isUserRoleName == 'admin') &&
            (stage == 'Отправка в ЕИС' || stage == 'План закупки в ЕИС')
        ) {
            checkPlanVersion()
                .then((result) => {
                    if (result.plan_published) {
                        if (result && !result.plan_published.is_different) {
                            setPlanVersionDiff('')
                        } else {
                            setPlanVersionDiff(
                                result.plan_published.data.version
                            )
                        }
                    }

                    if (result && result.plan_compliance) {
                        setPlanCompliance(result.plan_compliance)
                    } else {
                        setPlanCompliance(null)
                    }
                })
                .catch((error) => {
                    console.error('Ошибка получения данных:', error)
                })
        }
    }, [stage])

    // Загрузка фильтра при изменении stage или planGuidNav
    useEffect(() => {
        setLoading(true)
        setLoadingPosition(true)
        setItems([])
        setPage(1)
        setFilterLoaded(false)

        getUserFilterTypeCategory(user?.object.user_id, stage, 'План')
            .then((data) => {
                setFilter(data)
                setFilterLoaded(true)
            })
            .catch((error) => {
                console.error(error)
                setFilter(null)
                setFilterLoaded(true)
            })
            .finally(() => {
                setLoading(false)
            })
    }, [stage])

    // useEffect(() => {
    //     // Синхронизируйте локальное состояние с маршрутом
    //     setPlanGuidNav(routePlanGuid)
    // }, [routePlanGuid])

    // Загрузка позиций при загрузке фильтра
    useEffect(() => {
        if (!filterLoaded) return

        loadPlanPositions(1, filter, stage)

        loadPositionDraftCountStage()
        loadCountPlan()
        loadSumPlan()
        loadSumMSPPlan()

        setSelectedItems([])
        setSelectAll(false)
    }, [filterLoaded, filter, stage])

    useEffect(() => {
        loadPlan()
    }, [reg_number])

    // Функция для обработки изменения состояния отдельного checkbox
    const handleCheckboxChange = (pos_guid: string) => {
        setSelectedItems((prevSelectedItems) => {
            if (prevSelectedItems.includes(pos_guid)) {
                return prevSelectedItems.filter((itemId) => itemId !== pos_guid)
            } else {
                return [...prevSelectedItems, pos_guid]
            }
        })
    }

    // Функция для обработки изменения состояния отдельного checkbox при нажатии правой кнопкой
    const handleRightClickCheckboxChange = (pos_guid: string) => {
        setSelectedItems((prevSelectedItems) => {
            if (prevSelectedItems.includes(pos_guid)) {
                return prevSelectedItems // Если уже выбран, ничего не меняем
            }
            return [...prevSelectedItems, pos_guid] // Добавляем в выбранные
        })
    }

    // useEffect для обновления changeItems и changeStatusItems
    useEffect(() => {
        if (selectedItems.length === 1) {
            const singleSelectedItem = items.find(
                (item) => item.guid === selectedItems[0]
            )
            if (singleSelectedItem) {
                setChangeItems([singleSelectedItem]) // Устанавливаем единственный элемент
                setChangeStatusItems(singleSelectedItem.status) // Устанавливаем статус
            }
        } else {
            setChangeItems([]) // Сбрасываем changeItems при выборе нескольких позиций
            setChangeStatusItems('') // Сбрасываем статус
        }

        // Проверяем наличие хотя бы одного элемента со статусом "A"
        const hasStatusA = items.some(
            (item) => selectedItems.includes(item.guid) && item.status === 'A'
        )
        setCanAnnulate(hasStatusA ? false : true)

        // Проверяем наличие хотя бы одного элемента со статусом "Черновик", или нет согласования, или идет согласование, или не согласовано
        if (
            orgData?.active_approval == true &&
            (isUserRoleName == 'initiator' || isUserRoleName == 'curator')
        ) {
            const hasStatusChernovik = items.some(
                (item) =>
                    selectedItems.includes(item.guid) &&
                    (item.position_status === 'Черновик' ||
                        item.approval_status === 0 ||
                        item.approval_status === 3 ||
                        item.approval_status === null)
            )
            setCanMoveReadyToSent(hasStatusChernovik ? false : true)
        } else {
            const hasStatusChernovik = items.some(
                (item) =>
                    selectedItems.includes(item.guid) &&
                    item.position_status === 'Черновик'
            )
            setCanMoveReadyToSent(hasStatusChernovik ? false : true)
        }

        // Проверяем наличие хотя бы одного элемента со статусом "Черновик"
        const hasStatusReady = items.some(
            (item) =>
                selectedItems.includes(item.guid) &&
                item.position_status === 'Готово'
        )
        setCanDeletePosition(hasStatusReady ? false : true)

        // Проверяем наличие хотя бы одного элемента со статусом "Готово"
        const hasStatusReadyToSentDone = items.some(
            (item) =>
                selectedItems.includes(item.guid) &&
                item.position_stage === 'Подготовка к размещению' &&
                item.position_status === 'Готово'
        )
        setCanMoveBackToEdit(hasStatusReadyToSentDone ? false : true)

        // Проверяем наличие хотя бы одного элемента со статусом "Подготовка"
        const hasStatusReadyToSentStand = items.some(
            (item) =>
                selectedItems.includes(item.guid) &&
                item.position_stage === 'Подготовка к размещению' &&
                item.position_status === 'Подготовка'
        )
        setCanMoveReadyToEis(hasStatusReadyToSentStand ? false : true)
    }, [selectedItems, items]) // Следим за изменениями selectedItems и items

    // Функция для обработки изменения состояния "Select All"
    const handleSelectAllChange = () => {
        setSelectAll(!selectAll)
        if (!selectAll) {
            // Выбираем только те элементы, которые соответствуют текущей стадии
            const filteredItems = items
                .filter((item) => item.position_stage === stage)
                .map((item) => item.guid)

            setSelectedItems(filteredItems)
        } else {
            // Сбрасываем выбор всех элементов
            setSelectedItems([])
        }
    }

    const handleChangePlanPositionPopup = () => {
        if (changePlanPositionPopup == false) {
            const filteredData = items.filter((item) =>
                selectedItems.includes(item.guid)
            )
            setChangeItems(filteredData)
        }
        setChangePlanPositionPopup(!changePlanPositionPopup)
    }

    const handleChangeClick = async () => {
        setCreating(true)

        let remainingChangeItems = [...selectedItems] // Копируем массив, чтобы избежать изменения оригинала.

        for (const item of selectedItems) {
            await changePosition(item) // Отправляем запрос на удаление.
            // Уменьшаем массив, убирая удалённый элемент.
            remainingChangeItems = remainingChangeItems.filter(
                (i) => i !== item
            )
            const filteredChangeItems = changeItems.filter((changeItem) =>
                remainingChangeItems.includes(changeItem.guid)
            )
            setChangeItems(filteredChangeItems)
        }
        setSelectedItems([])
        setSelectAll(false)
        setCreating(false)
        setChangePlanPositionPopup(false)
        loadPositionDraftCountStage()
    }

    const handleDeletePlanPositionPopup = () => {
        if (deletePlanPositionPopup == false) {
            const filteredData = items.filter((item) =>
                selectedItems.includes(item.guid)
            )
            setDeleteItems(filteredData)
        }
        setDeletePlanPositionPopup(!deletePlanPositionPopup)
    }

    const handleDeleteClick = async () => {
        setDeleting(true)

        let remainingDeleteItems = [...selectedItems] // Копируем массив, чтобы избежать изменения оригинала.

        for (const item of selectedItems) {
            await deletePosition(item) // Отправляем запрос на удаление.
            // Уменьшаем массив, убирая удалённый элемент.
            remainingDeleteItems = remainingDeleteItems.filter(
                (i) => i !== item
            )
            const filteredDeleteItems = deleteItems.filter((delItem) =>
                remainingDeleteItems.includes(delItem.guid)
            )
            setDeleteItems(filteredDeleteItems)
        }
        setSelectedItems([])
        loadPlanPositions(1, filter, stage)
        setSelectAll(false)
        setDeleting(false)
        setDeletePlanPositionPopup(false)
        loadPositionDraftCountStage()
    }

    const handleDeleteItem = (itemGuid: string) => {
        setDeleteItems((prevItems) =>
            prevItems.filter((item) => item.guid !== itemGuid)
        )
        setSelectedItems((prevSelectedItems) =>
            prevSelectedItems.filter(
                (selectedGuid) => selectedGuid !== itemGuid
            )
        )
    }

    const handleCopyPlanPositionPopup = () => {
        if (copyPlanPositionPopup == false) {
            const filteredData = items.filter((item) =>
                selectedItems.includes(item.guid)
            )
            setCopyItems(filteredData)
        }
        setCopyPlanPositionPopup(!copyPlanPositionPopup)
        console.log(selectedItems)
    }

    const handleCopyClick = async () => {
        setCopying(true)

        let remainingCopyItems = [...selectedItems] // Копируем массив, чтобы избежать изменения оригинала.

        for (const item of selectedItems) {
            await copyPosition(item) // Отправляем запрос на копирование.
            remainingCopyItems = remainingCopyItems.filter((i) => i !== item)

            const filteredCopyItems = copyItems.filter((copyItem) =>
                remainingCopyItems.includes(copyItem.guid)
            )
            setCopyItems(filteredCopyItems)
        }
        setSelectedItems([])
        setSelectAll(false)
        setCopying(false)
        setCopyPlanPositionPopup(false)
        setStage(PlanPositionStage.EDIT)
        loadPositionDraftCountStage()
    }

    const handleCopyItem = (itemGuid: string) => {
        setCopyItems((prevItems) =>
            prevItems.filter((item) => item.guid !== itemGuid)
        )
        setSelectedItems((prevSelectedItems) =>
            prevSelectedItems.filter(
                (selectedGuid) => selectedGuid !== itemGuid
            )
        )
    }

    const handleAnnulatePlanPositionPopup = () => {
        if (annulatePlanPositionPopup == false) {
            const filteredData = items.filter((item) =>
                selectedItems.includes(item.guid)
            )
            setAnnulateItems(filteredData)
        }
        setAnnulatePlanPositionPopup(!annulatePlanPositionPopup)
    }

    const handleAnnulateClick = async (cancellationReason: string) => {
        setAnnulating(true)

        let remainingAnnulateItems = [...selectedItems] // Копируем массив, чтобы избежать изменения оригинала.

        for (const item of selectedItems) {
            await annulatePosition(item, cancellationReason) // Отправляем запрос на копирование.
            remainingAnnulateItems = remainingAnnulateItems.filter(
                (i) => i !== item
            )

            const filteredAnnulateItems = annulateItems.filter((annulateItem) =>
                remainingAnnulateItems.includes(annulateItem.guid)
            )
            setAnnulateItems(filteredAnnulateItems)
        }
        setSelectedItems([])
        setSelectAll(false)
        setAnnulating(false)
        setAnnulatePlanPositionPopup(false)
        setStage(PlanPositionStage.READY_FOR_PLACEMENT)
        loadPositionDraftCountStage()
    }

    const handleAnnulateReasonChange = async (value: string) => {
        setAnnulateReason(value)
    }

    const handleAnnulateItem = (itemGuid: string) => {
        setAnnulateItems((prevItems) =>
            prevItems.filter((item) => item.guid !== itemGuid)
        )
        setSelectedItems((prevSelectedItems) =>
            prevSelectedItems.filter(
                (selectedGuid) => selectedGuid !== itemGuid
            )
        )
    }

    const handleCopyPlanPositionDraftPopup = () => {
        if (copyPlanPositionDraftPopup == false) {
            const filteredData = items.filter((item) =>
                selectedItems.includes(item.guid)
            )
            setCopyItems(filteredData)
        }
        setCopyPlanPositionDraftPopup(!copyPlanPositionDraftPopup)
    }

    const handleCopyDraftClick = async () => {
        setCopying(true)

        let remainingCopyItems = [...selectedItems] // Копируем массив, чтобы избежать изменения оригинала.

        for (const item of selectedItems) {
            await copyPositionDraft(item) // Отправляем запрос на копирование.
            remainingCopyItems = remainingCopyItems.filter((i) => i !== item)

            const filteredCopyItems = copyItems.filter((copyItem) =>
                remainingCopyItems.includes(copyItem.guid)
            )
            setCopyItems(filteredCopyItems)
        }
        setSelectedItems([])
        setSelectAll(false)
        setCopying(false)
        setCopyPlanPositionDraftPopup(false)
        if (stage == 'Редактирование') {
            loadPlanPositions(1, filter, stage)
        } else setStage(PlanPositionStage.EDIT)
        loadPositionDraftCountStage()
    }

    const handleCopyDraftItem = (itemGuid: string) => {
        setCopyItems((prevItems) =>
            prevItems.filter((item) => item.guid !== itemGuid)
        )
        setSelectedItems((prevSelectedItems) =>
            prevSelectedItems.filter(
                (selectedGuid) => selectedGuid !== itemGuid
            )
        )
    }

    const handleStatusChangePlanPositionPopup = (statusPos: string) => {
        if (statusChangePlanPositionPopup == false) {
            const filteredData = items.filter((item) =>
                selectedItems.includes(item.guid)
            )
            setStatusChangeItems(filteredData)
        }
        setStatusChangePlanPositionPopup(!statusChangePlanPositionPopup)
        setStatusChangeFlag(statusPos)
    }

    const handleStatusChangeClick = async () => {
        setStatusChanging(true)

        let remainingStatusChangeItems = [...selectedItems] // Копируем массив, чтобы избежать изменения оригинала.

        for (const item of selectedItems) {
            await statusChangePosition(item, statusChangeFlag) // Отправляем запрос на удаление.
            remainingStatusChangeItems = remainingStatusChangeItems.filter(
                (i) => i !== item
            )

            const filteredStatusChangeItems = statusChangeItems.filter(
                (statusChange) =>
                    remainingStatusChangeItems.includes(statusChange.guid)
            )
            setStatusChangeItems(filteredStatusChangeItems)
        }
        setSelectedItems([])
        loadPlanPositions(1, filter, stage)
        setSelectAll(false)
        setStatusChanging(false)
        setStatusChangeFlag('')
        setStatusChangePlanPositionPopup(false)
        loadPositionDraftCountStage()
    }

    const handleStatusChangeItem = (itemGuid: string) => {
        setStatusChangeItems((prevItems) =>
            prevItems.filter((item) => item.guid !== itemGuid)
        )
        setSelectedItems((prevSelectedItems) =>
            prevSelectedItems.filter(
                (selectedGuid) => selectedGuid !== itemGuid
            )
        )
    }

    const handleStageChangePlanPositionPopup = (stagePos: string) => {
        if (stageChangePlanPositionPopup == false) {
            const filteredData = selectedItems
                .map((guid) => items.find((item) => item.guid === guid))
                .filter((item): item is PlanPosition => item !== undefined)
            setStageChangeItems(filteredData)
        }
        setStageChangePlanPositionPopup(!stageChangePlanPositionPopup)
        setStageChangeFlag(stagePos)
        if (stage == 'Редактирование') {
            if (stagePos == 'Подготовка к размещению') {
                setStatusChangeFlag('Подготовка')
            }
        } else if (stage == 'Подготовка к размещению') {
            if (stagePos == 'Отправка в ЕИС') {
                setStatusChangeFlag('Готово к отправке')
            } else if (stagePos == 'Редактирование') {
                setStatusChangeFlag('Черновик')
            }
        } else if (stage == 'Отправка в ЕИС') {
            if (stagePos == 'Подготовка к размещению') {
                setStatusChangeFlag('Подготовка')
            }
        }
    }

    const handleStageChangeClick = async () => {
        setStageChanging(true)

        let remainingStageChangeItems = [...selectedItems] // Копируем массив, чтобы избежать изменения оригинала.

        for (const item of selectedItems) {
            await statusChangePosition(item, statusChangeFlag)
            await stageChangePosition(item, stageChangeFlag)
            remainingStageChangeItems = remainingStageChangeItems.filter(
                (i) => i !== item
            )

            const filteredStageChangeItems = stageChangeItems.filter(
                (stageChange) =>
                    remainingStageChangeItems.includes(stageChange.guid)
            )
            setStageChangeItems(filteredStageChangeItems)
        }
        setSelectedItems([])
        loadPlanPositions(1, filter, stage)
        setSelectAll(false)
        setStageChanging(false)
        setStageChangeFlag('')
        setStatusChangeFlag('')
        setStageChangePlanPositionPopup(false)
        loadPositionDraftCountStage()
    }

    const handleStageChangeItem = (itemGuid: string) => {
        setStageChangeItems((prevItems) =>
            prevItems.filter((item) => item.guid !== itemGuid)
        )
        setSelectedItems((prevSelectedItems) =>
            prevSelectedItems.filter(
                (selectedGuid) => selectedGuid !== itemGuid
            )
        )
    }

    const handleToEisSendPopup = () => {
        setToEisSendPopup(!toEisSendPopup)
    }

    const handleToEisSendClick = async () => {
        setToEisSending(true)
        await toEisSendPlan(toEisSendInfo)
        setToEisSending(false)
        loadPlanPositions(1, filter, stage)
        setToEisSendPopup(false)
        loadPositionDraftCountStage()
    }

    const handleToEisSendResponsePopup = () => {
        setToEisSendResponsePopup(!toEisSendResponsePopup)
    }

    const handleInputChange = (
        fieldName: keyof ToEisSendInfo,
        value: string
    ) => {
        setToEisSendInfo((prev) => ({
            ...prev,
            [fieldName]: value,
        }))
    }

    const handleUpdateFromEisPopup = () => {
        setUpdateFromEisPopup(!updateFromEisPopup)
        setPopupMessage('')
    }

    const handleTakeFromEisPopup = () => {
        setTakeFromEisPopup(!takeFromEisPopup)
        setPopupMessage('')
    }

    const handleTakeFromEisClick = async () => {
        await takePlanFromEis(takePlanFromEisInfo)
    }

    const handleInputPlanNumberChange = (
        fieldName: keyof TakePlanFromEis,
        value: string
    ) => {
        setTakePlanFromEisInfo((prev) => ({
            ...prev,
            [fieldName]: value,
        }))
    }

    const initialValue = 0
    const sum = items.reduce(
        (accumulator, currentValue) =>
            accumulator + Number(currentValue.maximum_contract_price),
        initialValue
    )

    // Закрыть меню при клике вне его
    useEffect(() => {
        const handleOutsideClick = () => setMenuVisible(false)
        window.addEventListener('click', handleOutsideClick)

        return () => window.removeEventListener('click', handleOutsideClick)
    }, [])

    const handleContextMenu = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault() // Отключаем стандартное контекстное меню
        setMenuPosition({ x: e.pageX, y: e.pageY }) // Устанавливаем позицию меню
        setMenuVisible(true) // Показываем меню
    }

    const handlePrint = async () => {
        setPrinting(true)

        // Загружаем все позиции
        const allPositions = await fetchAllPositions()

        // Устанавливаем загруженные позиции в состояние
        setItems(allPositions)

        setPrinting(false)

        // Открываем окно печати
        window.print()
    }

    const handleImportPlanPositionPopup = () => {
        setImportPlanPositionPopup(!importPlanPositionPopup)
    }

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0] || null
        setSelectedFile(file)
    }

    const handleFileUpload = async () => {
        if (!selectedFile) {
            setUploadMessage('Пожалуйста, выберите файл.')
            return
        }

        const formData = new FormData()
        formData.append('file', selectedFile) // Имя должно совпадать с ожидаемым на сервере

        setUploadMessage(null) // Очистка предыдущего сообщения
        setImporting(true)

        try {
            const response = await fetch(
                process.env.REACT_APP_API_URL +
                    `/api/backend/v2/import_positions_draft_from_file?reg_number=${reg_number}`,
                {
                    method: 'POST',
                    credentials: 'include',
                    body: formData,
                    headers: {
                        Accept: 'application/json', // Заголовок Accept для ответа в JSON
                    },
                }
            )

            if (!response.ok) {
                const errorData = await response.json()
                throw new Error(
                    errorData.detail?.[0]?.msg || 'Ошибка загрузки файла'
                )
            }

            const result = await response.json()
            setUploadMessage('Данные успешно импортированы.')
        } catch (error) {
            console.error(error)
            setUploadMessage((error as Error).message)
        } finally {
            setImporting(false)
            setImportPlanPositionPopup(!importPlanPositionPopup)
            loadPlanPositions(1, filter, stage)
            setSelectedFile(null)
        }
    }

    const handleFileUploadInitiator = async () => {
        if (!selectedFile) {
            setUploadMessage('Пожалуйста, выберите файл.')
            return
        }

        const formData = new FormData()
        formData.append('file', selectedFile) // Имя должно совпадать с ожидаемым на сервере

        setUploadMessage(null) // Очистка предыдущего сообщения
        setImporting(true)

        try {
            const response = await fetch(
                process.env.REACT_APP_API_URL +
                    `/api/backend/v2/import_positions_draft_from_file_for_initiator?reg_number=${reg_number}`,
                {
                    method: 'POST',
                    credentials: 'include',
                    body: formData,
                    headers: {
                        Accept: 'application/json', // Заголовок Accept для ответа в JSON
                    },
                }
            )

            if (!response.ok) {
                const errorData = await response.json()
                throw new Error(
                    errorData.detail?.[0]?.msg || 'Ошибка загрузки файла'
                )
            }

            const result = await response.json()
            setUploadMessage('Данные успешно импортированы.')
        } catch (error) {
            console.error(error)
            setUploadMessage((error as Error).message)
        } finally {
            setImporting(false)
            setImportPlanPositionPopup(!importPlanPositionPopup)
            loadPlanPositions(1, filter, stage)
            setSelectedFile(null)
        }
    }

    const handleExport = async () => {
        const url =
            process.env.REACT_APP_API_URL +
            `/api/backend/v2/export_plan_positions_to_file?reg_number=${reg_number}`

        setExporting(true) // Устанавливаем состояние загрузки
        try {
            const response = await fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                },
            })

            if (!response.ok) {
                throw new Error(`Error: ${response.statusText}`)
            }

            // Получение имени файла из заголовков
            const disposition = response.headers.get('Content-Disposition')
            const filename =
                disposition?.match(/filename="?(.+)"?/)?.[1] ||
                'exported_file.xlsx'

            // Чтение файла и создание ссылки для скачивания
            const blob = await response.blob()
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = filename
            link.click()
            window.URL.revokeObjectURL(link.href) // Очистка URL
        } catch (error) {
            console.error('Error exporting file:', error)
            alert('Ошибка экспорта файла.')
        } finally {
            setExporting(false) // Завершаем состояние загрузки
        }
    }

    const handleExportExcel = async () => {
        const url =
            process.env.REACT_APP_API_URL +
            `/api/backend/v2/export_plan_to_file?reg_number=${reg_number}`

        setExporting(true) // Устанавливаем состояние загрузки
        try {
            const response = await fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                },
            })

            if (!response.ok) {
                throw new Error(`Error: ${response.statusText}`)
            }

            // Получение имени файла из заголовков
            const disposition = response.headers.get('Content-Disposition')
            const filename =
                disposition?.match(/filename="?(.+)"?/)?.[1] ||
                'Сведения плана закупки.xlsx'

            // Чтение файла и создание ссылки для скачивания
            const blob = await response.blob()
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = filename
            link.click()
            window.URL.revokeObjectURL(link.href) // Очистка URL
        } catch (error) {
            console.error('Error exporting file:', error)
            alert('Ошибка экспорта файла.')
        } finally {
            setExporting(false) // Завершаем состояние загрузки
        }
    }

    const handlePositionsExportExcel = async () => {
        const prefixUrl =
            stage === PlanPositionStage.PURCHASE_PLAN_IN_EIS
                ? 'export_positions_to_file'
                : 'export_positions_draft_to_file'

        const url =
            process.env.REACT_APP_API_URL +
            `/api/backend/v2/${prefixUrl}?reg_number=${reg_number}`

        setExporting(true) // Устанавливаем состояние загрузки
        try {
            const response = await fetch(url, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    pos_guid: selectedItems,
                }),
            })

            if (!response.ok) {
                throw new Error(`Error: ${response.statusText}`)
            }

            // Получение имени файла из заголовков
            const disposition = response.headers.get('Content-Disposition')
            const filename =
                disposition?.match(/filename="?(.+)"?/)?.[1] ||
                'Позиции плана закупок.xlsx'

            // Чтение файла и создание ссылки для скачивания
            const blob = await response.blob()
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = filename
            link.click()
            window.URL.revokeObjectURL(link.href) // Очистка URL
        } catch (error) {
            console.error('Error exporting file:', error)
            alert('Ошибка экспорта файла.')
        } finally {
            setExporting(false) // Завершаем состояние загрузки
        }
    }

    // // Отдельный эффект на изменение filter:
    // useEffect(() => {
    //     if (filter && filter?.filter_settings?.filter_enabled) {
    //         loadPlanPositions(1, filter)
    //     } else if (filter) {
    //         loadPlanPositions() // Если фильтр есть, но он отключен
    //     }
    // }, [filter]) // <-- Запускается только после обновления filter

    const handleFilterChange = async (currentFilter?: UserFilter) => {
        const filterToUse = currentFilter || filter

        if (!filterToUse) return

        try {
            const updatedFilter = await updateUserFilter(
                {
                    filter_type: stage,
                    filter_settings: filterToUse.filter_settings,
                    filter_category: 'План',
                },
                filterToUse.guid
            )

            // setFilter(updatedFilter)
        } catch (error) {
            console.error('Ошибка обновления фильтра:', error)
        }
    }

    const handleFilterErase = async () => {
        if (filter) {
            try {
                const updatedFilter = await updateUserFilter(
                    {
                        filter_type: stage,
                        filter_settings: {
                            criteria: null,
                            filter_enabled: true,
                        },
                        filter_category: 'План',
                    },
                    filter.guid
                )
                setFilter(updatedFilter)
            } catch (error) {
                console.error('Ошибка обновления фильтра:', error)
            }
        }
    }

    // Функция, вызываемая по нажатию на кнопку
    const handleFilter = async () => {
        if (!filter) {
            try {
                const newFilter = await createUserFilter({
                    filter_type: stage,
                    filter_settings: {
                        criteria: null,
                        filter_enabled: true,
                    },
                    filter_category: 'План',
                })

                setFilter(newFilter)
            } catch (error) {
                console.error('Ошибка создания фильтра:', error)
            }
        } else {
            const currentSettings = filter.filter_settings || {
                filter_enabled: false,
                criteria: {} as Criteria,
            }

            const newFilter: UserFilter = {
                ...filter,
                filter_settings: {
                    ...currentSettings,
                    filter_enabled: !currentSettings.filter_enabled,
                },
            }

            try {
                const updatedFilter = await updateUserFilter(
                    {
                        filter_type: newFilter.filter_type,
                        filter_settings: newFilter.filter_settings,
                        filter_category: 'План',
                    },
                    newFilter.guid
                )

                setFilter(updatedFilter)
            } catch (error) {
                console.error('Ошибка обновления фильтра:', error)
            }
        }
    }

    useEffect(() => {
        const checkHasAttachments = async () => {
            if (stage != 'Отправка в ЕИС') return

            try {
                const response = await fetch(
                    process.env.REACT_APP_API_URL +
                        `/api/backend/v2/attachments?reg_number=${reg_number}`,
                    {
                        method: 'GET',
                        credentials: 'include',
                        headers: {
                            Accept: 'application/json',
                        },
                    }
                )

                const data = await response.json()

                const ready = data.filter(
                    (item: any) =>
                        item.attachment_status === 'Готово к отправке'
                )

                setAttachment(ready.length > 0)
            } catch (err) {
                console.error('Ошибка при проверке вложений', err)
            }
        }

        checkHasAttachments()
    }, [stage])

    const addContract = async (guid: string) => {
        try {
            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/api/backend/v1/contract_new_draft_from_plan_position?plan_position_guid=${guid}`,
                {
                    method: 'POST',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' },
                }
            )

            if (!res.ok) {
                throw new Error('Ошибка создания договора из позиции плана')
            }

            const newContract = await res.json()

            navigate(
                `/hub/contract/${newContract.contract_reg_number}/contracts/draft/${newContract.guid}`,
                {
                    state: {
                        from: 'registry',
                        fromStage: 'Редактирование',
                        fromYear: plan[0].start_date.split('-')[0],
                    },
                }
            )
            setCreating(false)
        } catch (e) {
            console.error(e)
        }
    }

    const handleAddContractPopup = () => {
        setAddContractPopup(!addContractPopup)
    }

    const handleAddContractClick = async () => {
        setCreating(true)
        for (const item of selectedItems) {
            await addContract(item) // Создаем контракт
        }
        setSelectedItems([])
        setSelectAll(false)
        setAddContractPopup(false)
    }

    return (
        <div className="h-full flex flex-col bg-[#f0f3f5] dark:bg-[#181818]">
            <div className="bg-[#e5e5e5] dark:bg-[#111111]">
                <PlanPositionsHeader
                    positionCount={countPlan}
                    sum={sumPlan}
                    mspSum={sumMSPPlan}
                    percentMspSum={sumMSPPlanPercent}
                    plan={plan.length > 0 ? plan[0] : undefined}
                    planVersion={planVersion}
                    loadPlan={!isLoadingPlan}
                    planVersionDiff={planVersionDiff}
                    planCompliance={planCompliance}
                    onUpdate={() => updatePlanFromEis()}
                    theme={theme}
                    organizationCompliance={orgData?.is_compliance_smb}
                    isUserRoleName={isUserRoleName}
                />
                <PlanPositionsTabs
                    stage={stage}
                    edit={editStage}
                    ready={readyStage}
                    sent={sentStage}
                    onTabChange={(newStage) => {
                        setStage(newStage)
                    }}
                    onTabClick={(selectAllFlag) => setSelectAll(selectAllFlag)}
                    theme={theme}
                />
            </div>

            {/* // body */}
            <div className="plan-positions flex p-5 h-[calc(100vh_-_96px_-_28px)]">
                {/* table */}
                <div
                    id="printable-content"
                    className="flex flex-col w-full rounded bg-[#e4e6e8] dark:bg-[#1D1C1E]"
                >
                    {/* table toolbar */}
                    <div className="flex flex-row gap-2 p-2 h-10 rounded-t text-[#181818] dark:text-[#FFFFFF] bg-[#d2d5d8] dark:bg-[#333033]">
                        <HoverTooltip tooltipText="Выделить все">
                            <div className="w-6 h-6 grid rounded-full place-items-center hover:bg-[#FFFFFF] dark:hover:bg-[#656365]">
                                <input
                                    type="checkbox"
                                    className="p-2"
                                    checked={selectAll}
                                    onChange={handleSelectAllChange}
                                />
                            </div>
                        </HoverTooltip>

                        <TableStageToolbarButtons
                            role={isUserRoleName}
                            stage={stage}
                            isSelect={selectedItems.length > 0}
                            isChernovik={canMoveReadyToSent}
                            isReady={canDeletePosition}
                            isCanMoveBackToEdit={canMoveBackToEdit}
                            isCanMoveReadyToEis={canMoveReadyToEis}
                            isSendPlan={isSendPlan}
                            isUpdatingFromEis={isUpdatingFromEis}
                            isAnnulate={canAnnulate}
                            multiSelect={selectedItems.length == 1}
                            planVersionDiff={planVersionDiff != ''}
                            filter={filter}
                            theme={theme}
                            actions={{
                                add: () =>
                                    navigate(
                                        `/hub/plans/${reg_number}/positions/new`
                                    ),
                                ready_to_sent: () =>
                                    handleStageChangePlanPositionPopup(
                                        'Подготовка к размещению'
                                    ),
                                return_to_edit: () =>
                                    handleStageChangePlanPositionPopup(
                                        'Редактирование'
                                    ),
                                ready_to_eis: () =>
                                    handleStageChangePlanPositionPopup(
                                        'Отправка в ЕИС'
                                    ),
                                return_to_ready: () =>
                                    handleStageChangePlanPositionPopup(
                                        'Подготовка к размещению'
                                    ),
                                sent_to_eis: handleToEisSendPopup,
                                ready_to_go_eis: () =>
                                    handleStatusChangePlanPositionPopup(
                                        'Готово к отправке'
                                    ),
                                update: () => updatePlanFromEis(),
                                export_plan: handleExport,
                                export_plan_excel: handleExportExcel,
                                copy: handleCopyPlanPositionPopup,
                                copy_draft: handleCopyPlanPositionDraftPopup,
                                delete: handleDeletePlanPositionPopup,
                                import_from_file: handleImportPlanPositionPopup,
                                print: handlePrint,
                                change: handleChangePlanPositionPopup,
                                annulate: handleAnnulatePlanPositionPopup,
                                filter: handleFilter,
                            }}
                            // status = {}
                            // multiSelect = {selectedItems.length > 0}
                        />
                        <div className="flex flex-1"></div>

                        {user?.object.login == 'user1@example.com' ||
                        user?.object.login == 'userstng@example.com' ||
                        user?.object.login == 'userpolar@example.com' ||
                        user?.object.login == 'userlorp@example.com' ||
                        user?.object.login == 'usersngs@example.com' ||
                        user?.object.login == 'useryxk@example.com' ||
                        user?.object.login == 'userport@example.com' ||
                        user?.object.login == 'userkap@example.com' ? (
                            <TableStageToolbarAdminButtons
                                role={isUserRoleName}
                                stage={stage}
                                isSelect={selectedItems.length > 0}
                                isChernovik={canMoveReadyToSent}
                                isReady={canDeletePosition}
                                isCanMoveBackToEdit={canMoveBackToEdit}
                                isCanMoveReadyToEis={canMoveReadyToEis}
                                isSendPlan={isSendPlan}
                                isUpdatingFromEis={isUpdatingFromEis}
                                isAnnulate={canAnnulate}
                                multiSelect={selectedItems.length == 1}
                                planVersionDiff={planVersionDiff != ''}
                                filter={filter}
                                theme={theme}
                                actions={{
                                    ready_to_eis: () =>
                                        handleStageChangePlanPositionPopup(
                                            'Отправка в ЕИС'
                                        ),
                                    ready_to_go_eis: () =>
                                        handleStatusChangePlanPositionPopup(
                                            'Готово к отправке'
                                        ),
                                    status_send_to_eis: () =>
                                        handleStatusChangePlanPositionPopup(
                                            'Отправлено в ЕИС'
                                        ),
                                    delete: handleDeletePlanPositionPopup,
                                }}
                                // status = {}
                                // multiSelect = {selectedItems.length > 0}
                            />
                        ) : (
                            ''
                        )}
                    </div>

                    {/* table header (name) */}
                    {stage != 'План закупки в ЕИС' ? (
                        <TableHeaderDraft
                            stage={stage}
                            hasScroll={hasScroll}
                            filter={filter}
                            theme={theme}
                            onFilterErase={() => {
                                handleFilterErase()
                            }}
                            onAcceptFilter={() => {
                                handleFilterChange()
                            }}
                            // Фильтрация для "Согласования"
                            onChangeFilterSettingCriteriaApprovalStatus={(
                                values
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            approval_status: {
                                                ...filter.filter_settings
                                                    .criteria?.approval_status,
                                                values:
                                                    values === null
                                                        ? null
                                                        : values, // если values равно null, передаем undefined
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (values == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaApprovalStatusSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            approval_status: {
                                                ...filter.filter_settings
                                                    .criteria?.approval_status,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "Статуса позиции"
                            onChangeFilterSettingCriteriaPositionStatus={(
                                values
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            position_status: {
                                                ...filter.filter_settings
                                                    .criteria?.position_status,
                                                values:
                                                    values === null
                                                        ? null
                                                        : values, // если values равно null, передаем undefined
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (values == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaPositionStatusSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            position_status: {
                                                ...filter.filter_settings
                                                    .criteria?.position_status,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "Предмета договора"
                            onChangeFilterSettingCriteriaContractSubject={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            contract_subject: {
                                                ...filter.filter_settings
                                                    .criteria?.contract_subject,
                                                query: value,
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaContractSubjectSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            contract_subject: {
                                                ...filter.filter_settings
                                                    .criteria?.contract_subject,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "НМЦД"
                            onChangeFilterSettingCriteriaMaximumContractPrice={(
                                valueMin,
                                valueMax
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            maximum_contract_price: {
                                                ...filter.filter_settings
                                                    .criteria
                                                    ?.maximum_contract_price,
                                                min: valueMin,
                                                max: valueMax,
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (valueMin == null || valueMax == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaMaximumContractPriceSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            maximum_contract_price: {
                                                ...filter.filter_settings
                                                    .criteria
                                                    ?.maximum_contract_price,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "Даты размщения"
                            onChangeFilterSettingCriteriaPurchasePlannedDate={(
                                valueFrom,
                                valueTo
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            purchase_planned_date: {
                                                ...filter.filter_settings
                                                    .criteria
                                                    ?.purchase_planned_date,
                                                from: valueFrom,
                                                to: valueTo,
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (valueFrom == null || valueTo == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaPurchasePlannedDateSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            purchase_planned_date: {
                                                ...filter.filter_settings
                                                    .criteria
                                                    ?.purchase_planned_date,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "Срок исполнения"
                            onChangeFilterSettingCriteriaContractEndDate={(
                                valueFrom,
                                valueTo
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            contract_end_date: {
                                                ...filter.filter_settings
                                                    .criteria
                                                    ?.contract_end_date,
                                                from: valueFrom,
                                                to: valueTo,
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (valueFrom == null || valueTo == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaContractEndDateSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            contract_end_date: {
                                                ...filter.filter_settings
                                                    .criteria
                                                    ?.contract_end_date,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "Способ закупки "
                            onChangeFilterSettingCriteriaPurchaseMethodCode={(
                                values
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            purchase_method_code: {
                                                ...filter.filter_settings
                                                    .criteria
                                                    ?.purchase_method_code,
                                                values:
                                                    values === null
                                                        ? null
                                                        : values, // если values равно null, передаем undefined
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (values == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaPurchaseMethodCodeSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            purchase_method_code: {
                                                ...filter.filter_settings
                                                    .criteria
                                                    ?.purchase_method_code,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "Статус в плане"
                            onChangeFilterSettingCriteriaStatus={(values) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            status: {
                                                ...filter.filter_settings
                                                    .criteria?.status,
                                                values:
                                                    values === null
                                                        ? null
                                                        : values, // если values равно null, передаем undefined
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (values == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaStatusSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            status: {
                                                ...filter.filter_settings
                                                    .criteria?.status,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "Тип объекта закупки"
                            onChangeFilterSettingCriteriaTypeObjectPurchasePosition={(
                                values
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            type_object_purchase_position: {
                                                ...filter.filter_settings
                                                    .criteria
                                                    ?.type_object_purchase_position,
                                                values:
                                                    values === null
                                                        ? null
                                                        : values, // если values равно null, передаем undefined
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (values == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaTypeObjectPurchasePositionSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            type_object_purchase_position: {
                                                ...filter.filter_settings
                                                    .criteria
                                                    ?.type_object_purchase_position,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "Подразделение"
                            onChangeFilterSettingCriteriaStructGuid={(
                                values
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            struct_guid: {
                                                ...filter.filter_settings
                                                    .criteria?.struct_guid,
                                                values:
                                                    values === null
                                                        ? null
                                                        : values, // если values равно null, передаем undefined
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (values == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaStructGuidSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            struct_guid: {
                                                ...filter.filter_settings
                                                    .criteria?.struct_guid,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "Дата создания"
                            onChangeFilterSettingCriteriaCreatedDate={(
                                valueFrom,
                                valueTo
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            sys_updated_at: {
                                                ...filter.filter_settings
                                                    .criteria?.sys_updated_at,
                                                from: valueFrom,
                                                to: valueTo,
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (valueFrom == null || valueTo == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaCreatedDateSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            sys_updated_at: {
                                                ...filter.filter_settings
                                                    .criteria?.sys_updated_at,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "Подразделение"
                            onChangeFilterSettingCriteriaUserGuid={(values) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            user_guid: {
                                                ...filter.filter_settings
                                                    .criteria?.user_guid,
                                                values:
                                                    values === null
                                                        ? null
                                                        : values, // если values равно null, передаем undefined
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (values == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaUserGuidSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            user_guid: {
                                                ...filter.filter_settings
                                                    .criteria?.user_guid,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                        />
                    ) : (
                        <TableHeader
                            stage={stage}
                            hasScroll={hasScroll}
                            filter={filter}
                            theme={theme}
                            onFilterErase={() => {
                                handleFilterErase()
                            }}
                            onAcceptFilter={() => {
                                handleFilterChange()
                            }}
                            // Фильтрация для "Согласования"
                            onChangeFilterSettingCriteriaApprovalStatus={(
                                values
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            approval_status: {
                                                ...filter.filter_settings
                                                    .criteria?.approval_status,
                                                values:
                                                    values === null
                                                        ? null
                                                        : values, // если values равно null, передаем undefined
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (values == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaApprovalStatusSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            approval_status: {
                                                ...filter.filter_settings
                                                    .criteria?.approval_status,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "Статуса позиции"
                            onChangeFilterSettingCriteriaPositionStatus={(
                                values
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            position_status: {
                                                ...filter.filter_settings
                                                    .criteria?.position_status,
                                                values:
                                                    values === null
                                                        ? null
                                                        : values, // если values равно null, передаем undefined
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (values == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaPositionStatusSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            position_status: {
                                                ...filter.filter_settings
                                                    .criteria?.position_status,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "Предмета договора"
                            onChangeFilterSettingCriteriaContractSubject={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            contract_subject: {
                                                ...filter.filter_settings
                                                    .criteria?.contract_subject,
                                                query: value,
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaContractSubjectSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            contract_subject: {
                                                ...filter.filter_settings
                                                    .criteria?.contract_subject,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "Предмета договора"
                            onChangeFilterSettingCriteriaOrdinalNumber={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            ordinal_number: {
                                                ...filter.filter_settings
                                                    .criteria?.ordinal_number,
                                                query: value,
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaOrdinalNumberSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            ordinal_number: {
                                                ...filter.filter_settings
                                                    .criteria?.ordinal_number,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "НМЦД"
                            onChangeFilterSettingCriteriaMaximumContractPrice={(
                                valueMin,
                                valueMax
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            maximum_contract_price: {
                                                ...filter.filter_settings
                                                    .criteria
                                                    ?.maximum_contract_price,
                                                min: valueMin,
                                                max: valueMax,
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (valueMin == null || valueMax == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaMaximumContractPriceSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            maximum_contract_price: {
                                                ...filter.filter_settings
                                                    .criteria
                                                    ?.maximum_contract_price,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "Даты размщения"
                            onChangeFilterSettingCriteriaPurchasePlannedDate={(
                                valueFrom,
                                valueTo
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            purchase_planned_date: {
                                                ...filter.filter_settings
                                                    .criteria
                                                    ?.purchase_planned_date,
                                                from: valueFrom,
                                                to: valueTo,
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (valueFrom == null || valueTo == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaPurchasePlannedDateSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            purchase_planned_date: {
                                                ...filter.filter_settings
                                                    .criteria
                                                    ?.purchase_planned_date,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "Срок исполнения"
                            onChangeFilterSettingCriteriaContractEndDate={(
                                valueFrom,
                                valueTo
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            contract_end_date: {
                                                ...filter.filter_settings
                                                    .criteria
                                                    ?.contract_end_date,
                                                from: valueFrom,
                                                to: valueTo,
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (valueFrom == null || valueTo == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaContractEndDateSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            contract_end_date: {
                                                ...filter.filter_settings
                                                    .criteria
                                                    ?.contract_end_date,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "Способ закупки "
                            onChangeFilterSettingCriteriaPurchaseMethodCode={(
                                values
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            purchase_method_code: {
                                                ...filter.filter_settings
                                                    .criteria
                                                    ?.purchase_method_code,
                                                values:
                                                    values === null
                                                        ? null
                                                        : values, // если values равно null, передаем undefined
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (values == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaPurchaseMethodCodeSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            purchase_method_code: {
                                                ...filter.filter_settings
                                                    .criteria
                                                    ?.purchase_method_code,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "Статус в плане"
                            onChangeFilterSettingCriteriaStatus={(values) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            status: {
                                                ...filter.filter_settings
                                                    .criteria?.status,
                                                values:
                                                    values === null
                                                        ? null
                                                        : values, // если values равно null, передаем undefined
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (values == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaStatusSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            status: {
                                                ...filter.filter_settings
                                                    .criteria?.status,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "Тип объекта закупки"
                            onChangeFilterSettingCriteriaTypeObjectPurchasePosition={(
                                values
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            type_object_purchase_position: {
                                                ...filter.filter_settings
                                                    .criteria
                                                    ?.type_object_purchase_position,
                                                values:
                                                    values === null
                                                        ? null
                                                        : values, // если values равно null, передаем undefined
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (values == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaTypeObjectPurchasePositionSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            type_object_purchase_position: {
                                                ...filter.filter_settings
                                                    .criteria
                                                    ?.type_object_purchase_position,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "Подразделение"
                            onChangeFilterSettingCriteriaStructGuid={(
                                values
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            struct_guid: {
                                                ...filter.filter_settings
                                                    .criteria?.struct_guid,
                                                values:
                                                    values === null
                                                        ? null
                                                        : values, // если values равно null, передаем undefined
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (values == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaStructGuidSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            struct_guid: {
                                                ...filter.filter_settings
                                                    .criteria?.struct_guid,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "Дата создания"
                            onChangeFilterSettingCriteriaCreatedDate={(
                                valueFrom,
                                valueTo
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            sys_updated_at: {
                                                ...filter.filter_settings
                                                    .criteria?.sys_updated_at,
                                                from: valueFrom,
                                                to: valueTo,
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (valueFrom == null || valueTo == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaCreatedDateSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            sys_updated_at: {
                                                ...filter.filter_settings
                                                    .criteria?.sys_updated_at,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            // Фильтрация для "Подразделение"
                            onChangeFilterSettingCriteriaUserGuid={(values) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            user_guid: {
                                                ...filter.filter_settings
                                                    .criteria?.user_guid,
                                                values:
                                                    values === null
                                                        ? null
                                                        : values, // если values равно null, передаем undefined
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (values == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                            onChangeFilterSettingCriteriaUserGuidSort={(
                                value
                            ) => {
                                if (!filter) return // Если фильтра ещё нет, ничего не делаем
                                const newFilter: UserFilter = {
                                    ...filter,
                                    filter_settings: {
                                        ...filter.filter_settings,
                                        criteria: {
                                            ...filter.filter_settings.criteria,
                                            user_guid: {
                                                ...filter.filter_settings
                                                    .criteria?.user_guid,
                                                sort_order: value, // Обновляем только сортировку
                                            },
                                        },
                                    },
                                }
                                setFilter(newFilter)

                                if (value == null) {
                                    handleFilterChange(newFilter)
                                }
                            }}
                        />
                    )}

                    {/* table data */}
                    <div
                        ref={scrollRef}
                        className="flex flex-col gap-1 my-1 h-dvh overflow-y-auto custom-scrollbar"
                        onScroll={(e) => {
                            const { scrollTop, scrollHeight, clientHeight } =
                                e.currentTarget

                            if (
                                page !== -1 &&
                                !isLoadingPosition &&
                                scrollHeight - scrollTop - clientHeight < 100
                            ) {
                                if (filter?.filter_settings?.filter_enabled) {
                                    loadPlanPositions(page, filter, stage)
                                } else {
                                    loadPlanPositions(page, null, stage)
                                }
                            }
                        }}
                        onContextMenu={handleContextMenu} // Обрабатываем правый клик
                    >
                        {/* Вывод позиций */}
                        <>
                            {isLoadingPosition && items.length === 0 ? (
                                <div className="flex w-full h-full items-center justify-center">
                                    <LoadingIcon />
                                </div>
                            ) : !items.length ? (
                                <div className="flex w-full h-12 items-center justify-center text-[#6A6A6A] dark:text-[#8A8A8A] text-[11px]">
                                    Нет данных
                                </div>
                            ) : (
                                items.map((item, index) => (
                                    <PlanPositionsTableRow
                                        key={item.guid}
                                        stage={stage}
                                        keyindex={index + 1}
                                        planPosition={item}
                                        structData={structureList}
                                        selected={selectedItems.includes(
                                            item.guid
                                        )}
                                        onClick={(guid) => {
                                            handleCheckboxChange(guid)
                                        }}
                                        onDoubleClick={(pos_guid) => {
                                            const action =
                                                stage ===
                                                PlanPositionStage.PURCHASE_PLAN_IN_EIS
                                                    ? 'edit'
                                                    : 'draft'

                                            navigate(
                                                `/hub/plans/${reg_number}/positions/${action}/${pos_guid}`
                                            )
                                        }}
                                        onRightClick={(guid) => {
                                            handleRightClickCheckboxChange(guid)
                                        }}
                                        theme={theme}
                                        currency={currencyList}
                                    />
                                ))
                            )}
                            {isLoadingPosition &&
                                page > 1 &&
                                items.length > 0 && (
                                    <div className="flex w-full items-center justify-center">
                                        <LoadingIcon />
                                    </div>
                                )}
                        </>
                    </div>

                    {/* table buttons */}
                    <div className="flex flex-row gap-3 p-2 px-[22px] rounded-b h-10 text-[#181818] dark:text-[#FFFFFF] bg-[#d2d5d8] dark:bg-[#333033]">
                        <TableStageToolbarDownButtons
                            role={isUserRoleName}
                            stage={stage}
                            isSelect={selectedItems.length > 0}
                            isChernovik={canMoveReadyToSent}
                            isReady={canDeletePosition}
                            isCanMoveBackToEdit={canMoveBackToEdit}
                            isCanMoveReadyToEis={canMoveReadyToEis}
                            isSendPlan={isSendPlan}
                            isUpdatingFromEis={isUpdatingFromEis}
                            isAnnulate={canAnnulate}
                            multiSelect={selectedItems.length == 1}
                            planVersionDiff={planVersionDiff != ''}
                            theme={theme}
                            actions={{
                                add: () =>
                                    navigate(
                                        `/hub/plans/${reg_number}/positions/new`
                                    ),
                                ready_to_sent: () =>
                                    handleStageChangePlanPositionPopup(
                                        'Подготовка к размещению'
                                    ),
                                return_to_edit: () =>
                                    handleStageChangePlanPositionPopup(
                                        'Редактирование'
                                    ),
                                ready_to_eis: () =>
                                    handleStageChangePlanPositionPopup(
                                        'Отправка в ЕИС'
                                    ),
                                return_to_ready: () =>
                                    handleStageChangePlanPositionPopup(
                                        'Подготовка к размещению'
                                    ),
                                sent_to_eis: handleToEisSendPopup,
                                update: () => updatePlanFromEis(),
                                export_plan: handleExport,
                                export_plan_excel: handleExportExcel,
                                export_positions_to_excel:
                                    handlePositionsExportExcel,
                                copy: handleCopyPlanPositionPopup,
                                copy_draft: handleCopyPlanPositionDraftPopup,
                                delete: handleDeletePlanPositionPopup,
                                import_from_file: handleImportPlanPositionPopup,
                                print: handlePrint,
                                change: handleChangePlanPositionPopup,
                                annulate: handleAnnulatePlanPositionPopup,
                            }}
                            // status = {}
                            // multiSelect = {selectedItems.length > 0}
                        />
                    </div>
                </div>
            </div>

            {addContractPopup && (
                <div className="fixed top-0 left-0 w-full h-full bg-[#00000050] flex justify-center items-center z-50">
                    <div
                        className="p-5 rounded-lg bg-[#e5e5e5] dark:bg-[#262427] w-fit max-h-[600px]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex flex-col text-sm text-[#181818] dark:text-[#FFFFFF] items-center justify-center gap-5">
                            <div className="flex flex-col">
                                <label className="flex mb-1 text-sm text-[#181818] dark:text-[#FFFFFF]">
                                    Создать договор?
                                </label>
                            </div>
                            <div className="flex w-full flex-row items-center justify-end gap-3">
                                <button
                                    className="flex flex-row min-w-[120px] h-6 px-4 rounded-[10px] justify-center items-center gap-2 text-xs shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] dark:bg-[#494849] hover:bg-[#FFFFFF] dark:hover:bg-[#656365]"
                                    onClick={() => {
                                        setAddContractPopup(false)
                                    }}
                                >
                                    Отмена
                                </button>
                                <button
                                    className="flex px-4 py-1 min-w-[120px] h-6 rounded-[10px] items-center justify-center text-xs shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#83d2b7] hover:bg-[#8ce5c6] dark:bg-[#187A33] dark:hover:bg-[#1D9A40] "
                                    onClick={handleAddContractClick}
                                >
                                    Создать
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {deletePlanPositionPopup && (
                <div
                    className="fixed top-0 left-0 w-full h-full bg-[#000000] bg-opacity-50 flex justify-center items-center"
                    onClick={handleDeletePlanPositionPopup}
                >
                    <div
                        className="p-5 rounded-lg bg-[#e5e5e5] dark:bg-[#262427] w-[600px] max-h-[600px]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex flex-row w-full items-center justify-stsrt gap-2">
                            <svg
                                className="w-5 h-5"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                id="times-circle"
                            >
                                <path
                                    fill="#C15C5C"
                                    d="M15.71,8.29a1,1,0,0,0-1.42,0L12,10.59,9.71,8.29A1,1,0,0,0,8.29,9.71L10.59,12l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l2.29,2.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L13.41,12l2.3-2.29A1,1,0,0,0,15.71,8.29Zm3.36-3.36A10,10,0,1,0,4.93,19.07,10,10,0,1,0,19.07,4.93ZM17.66,17.66A8,8,0,1,1,20,12,7.95,7.95,0,0,1,17.66,17.66Z"
                                ></path>
                            </svg>
                            <h2 className="text-[#181818] dark:text-[#FFFFFF] text-[18px]">
                                Удаление позиции плана закупки
                            </h2>
                        </div>
                        <div className="flex flex-col mt-2 space-y-1">
                            <label className="text-[14px] text-[#181818] dark:text-[#FFFFFF]">
                                Вы уверены, что хотите удалить данные позиции
                                плана закупки? Это действие является
                                необратимым. Продолжить?
                            </label>
                            <div className="flex flex-row w-full space-x-5 pt-2">
                                <div className="flex flex-col w-full">
                                    {/* name */}
                                    <div className="flex flex-row gap-1 px-1 py-2 rounded-t-lg text-[10px] text-[#6A6A6A] dark:text-[#8A8A8A] bg-[#d2d5d8] dark:bg-[#333033]">
                                        <div className="flex w-10 items-center justify-center text-center">
                                            №
                                        </div>
                                        <div className="flex w-10 items-center justify-center text-center">
                                            № в ЕИС
                                        </div>
                                        <div className="flex flex-1 items-center justify-center text-center">
                                            Предмет договора
                                        </div>
                                        <div className="flex w-28 items-center justify-center text-center">
                                            НМЦД
                                        </div>
                                        <div className="flex w-6 items-center justify-center"></div>
                                    </div>
                                    {/* data */}
                                    <div className="flex flex-col h-[200px] gap-1 py-1 px-1 grow rounded-b-lg overflow-y-auto custom-scrollbar bg-[#e4e6e8] dark:bg-[#1D1C1E]">
                                        <div className="flex flex-col w-full space-y-1">
                                            {deleteItems.map((item, index) => (
                                                <div
                                                    key={item.guid}
                                                    className="flex flex-row rounded text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] hover:bg-[#FFFFFF] dark:bg-[#2A282B] dark:hover:bg-[#373538]"
                                                >
                                                    <div className="flex flex-row w-full">
                                                        <div className="flex flex-row min-h-8 flex-1 gap-1 text-[#181818] dark:text-[#FFFFFF] text-[11px]">
                                                            <div className="flex w-10 items-center justify-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                                                                {index + 1}
                                                            </div>
                                                            <div className="flex w-10 items-center justify-center">
                                                                {item.ordinal_number
                                                                    ? item.ordinal_number
                                                                    : '-'}
                                                            </div>
                                                            <div className="flex  flex-1 items-center justify-left p-1">
                                                                {item.contract_subject ? (
                                                                    <span className="fourrow">
                                                                        {
                                                                            item.contract_subject
                                                                        }
                                                                    </span>
                                                                ) : (
                                                                    '-'
                                                                )}
                                                            </div>
                                                            <div className="flex w-24 items-center justify-end">
                                                                <HoverTooltip
                                                                    tooltipText={
                                                                        item.currency_digital_code
                                                                            ? String(
                                                                                  currencyList.find(
                                                                                      (
                                                                                          c
                                                                                      ) =>
                                                                                          c.num_code ===
                                                                                          String(
                                                                                              item.currency_digital_code
                                                                                          )
                                                                                  )
                                                                                      ?.name
                                                                              )
                                                                            : '-'
                                                                    }
                                                                >
                                                                    <span>
                                                                        {Number(
                                                                            item.maximum_contract_price
                                                                        ).toLocaleString(
                                                                            'ru-RU',
                                                                            {
                                                                                minimumFractionDigits: 2,
                                                                            }
                                                                        )}{' '}
                                                                        {item.currency_digital_code
                                                                            ? item.currency_digital_code ==
                                                                              643
                                                                                ? ''
                                                                                : currencyList.find(
                                                                                      (
                                                                                          c
                                                                                      ) =>
                                                                                          c.num_code ===
                                                                                          String(
                                                                                              item.currency_digital_code
                                                                                          )
                                                                                  )
                                                                                      ?.char_sign ||
                                                                                  '?'
                                                                            : ''}
                                                                    </span>
                                                                </HoverTooltip>
                                                            </div>
                                                            <div className="flex w-8 items-center justify-center text-[#6A6A6A] dark:text-[#8A8A8A] ">
                                                                <button
                                                                    onClick={() =>
                                                                        handleDeleteItem(
                                                                            item.guid
                                                                        )
                                                                    }
                                                                    className=" flex w-6 h-6 rounded-full items-center justify-center hover:bg-[#ed9cae] dark:hover:bg-[#701F1F]"
                                                                >
                                                                    <svg
                                                                        className="w-3 h-3"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        viewBox="0 0 24 24"
                                                                        id="trash-alt"
                                                                    >
                                                                        <path
                                                                            fill={
                                                                                theme ==
                                                                                'dark'
                                                                                    ? '#FFFFFF'
                                                                                    : '#181818'
                                                                            }
                                                                            d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"
                                                                        ></path>
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-row mt-5 text-right justify-end gap-2">
                            <button
                                className={`flex px-4 py-1 min-w-[120px] h-6 rounded-[10px] ml-2 items-center justify-center text-xs shadow-md shadow-[#18181830] text-[#181818] bg-[#ed9cae] hover:bg-[#ffa7ba] dark:bg-[#701F1F] dark:hover:bg-[#9e2c2c] dark:text-[#FFFFFF]`}
                                onClick={handleDeleteClick} // Вызвать handleDelete
                                disabled={isDeleting ? true : false}
                            >
                                {isDeleting ? (
                                    <svg
                                        className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        ></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                        ></path>
                                    </svg>
                                ) : (
                                    'Удалить'
                                )}
                            </button>
                            {isDeleting ? (
                                ''
                            ) : (
                                <button
                                    className="flex flex-row min-w-[120px] h-6 px-4 rounded-[10px] justify-center items-center gap-2 text-xs shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] dark:bg-[#494849] hover:bg-[#FFFFFF] dark:hover:bg-[#656365]"
                                    onClick={handleDeletePlanPositionPopup}
                                >
                                    Отмена
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {changePlanPositionPopup && (
                <div
                    className="fixed top-0 left-0 w-full h-full bg-[#000000] bg-opacity-50 flex justify-center items-center"
                    onClick={handleChangePlanPositionPopup}
                >
                    <div
                        className="p-5 rounded-lg bg-[#e5e5e5] dark:bg-[#262427] w-[500px] max-h-[600px]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex flex-row w-full items-center justify-stsrt gap-2">
                            <svg
                                className="w-5 h-5"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                id="times-circle"
                            >
                                <path
                                    fill="#FFBF00"
                                    d="M12,14a1.25,1.25,0,1,0,1.25,1.25A1.25,1.25,0,0,0,12,14Zm0-1.5a1,1,0,0,0,1-1v-3a1,1,0,0,0-2,0v3A1,1,0,0,0,12,12.5ZM12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Z"
                                ></path>
                            </svg>
                            <h2 className="text-[#181818] dark:text-[#FFFFFF] text-[18px]">
                                Изменение позиции плана закупки
                            </h2>
                        </div>
                        <div className="flex flex-col mt-2 space-y-1">
                            <label className="text-[14px] text-[#181818] dark:text-[#FFFFFF]">
                                Позиция плана закупки размещена в ЕИС. Вы
                                уверены, что хотите внести изменения?
                            </label>
                            {/* {changeItems.map((item, index) => (
                                <label
                                    key={index}
                                    className="text-[12.8px] text-[#181818] dark:text-[#FFFFFF]"
                                >
                                    {`№ ${item.ordinal_number} - ${item.contract_subject}`}
                                </label>
                            ))} */}
                        </div>
                        <div className="flex flex-row mt-5 text-right justify-end">
                            {isCreating ? (
                                ''
                            ) : (
                                <button
                                    className="flex flex-row min-w-[120px] h-6 px-4 rounded-[10px] justify-center items-center gap-2 text-xs shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] dark:bg-[#494849] hover:bg-[#FFFFFF] dark:hover:bg-[#656365]"
                                    onClick={handleChangePlanPositionPopup}
                                >
                                    Отмена
                                </button>
                            )}
                            <button
                                className={`flex px-4 py-1 h-6 min-w-[120px] rounded-[10px] text-xs ml-2 items-center shadow-md shadow-[#18181830] justify-center text-[#181818] dark:text-[#FFFFFF] bg-[#83d2b7] hover:bg-[#8ce5c6] dark:bg-[#187A33] dark:hover:bg-[#1D9A40]`}
                                onClick={handleChangeClick}
                                disabled={isCopying ? true : false}
                            >
                                {isCreating ? (
                                    <svg
                                        className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        ></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                        ></path>
                                    </svg>
                                ) : (
                                    'Изменить'
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {importPlanPositionPopup && (
                <div
                    className="fixed top-0 left-0 w-full h-full bg-[#000000] bg-opacity-50 flex justify-center items-center"
                    onClick={handleImportPlanPositionPopup}
                >
                    <div
                        className="p-5 rounded-lg bg-[#e5e5e5] dark:bg-[#262427] w-[600px] max-h-[600px]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h2 className="text-[#181818] dark:text-[#FFFFFF]">
                            Импорт позиций из файла
                        </h2>
                        <div className="flex flex-col mt-2 space-y-1">
                            <label className="text-[14px] text-[#181818] dark:text-[#FFFFFF]">
                                Выберите файл для импорта
                            </label>
                            {/* Форма загрузки файла */}
                            <div className="flex flex-row bg-[#d2d5d8] dark:bg-[#333033] rounded-lg items-center">
                                <input
                                    type="file"
                                    accept=".xlsx"
                                    onChange={handleFileChange}
                                    className="w-full text-sm text-gray-500 file:w-[120px] file:cursor-pointer file:h-6 file:mr-4 file:px-5 file:rounded-[10px] file:border-0 file:text-[12.8px] file:bg-[#83d2b7] dark:file:bg-[#187A33] file:text-[#181818] dark:file:text-[#FFFFFF] hover:file:bg-[#8ce5c6] dark:hover:file:bg-[#16A34A] file:font-normal"
                                />
                                {/* <button
                                    onClick={handleFileUpload}
                                    className="flex h-7 bg-[#187A33] w-[180px] rounded-lg text-[12.8px] justify-center items-center"
                                    disabled={isLoading}
                                >
                                    Импортировать
                                </button> */}
                            </div>
                        </div>
                        <div className="flex flex-row mt-5 text-right justify-end gap-2">
                            {isImporting ? (
                                ''
                            ) : (
                                <button
                                    className="flex flex-row gap-2 px-4 py-1 min-w-[120px] items-center justify-center rounded-[10px] text-xs shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] dark:bg-[#494849] hover:bg-[#FFFFFF] dark:hover:bg-[#656365]"
                                    onClick={handleImportPlanPositionPopup}
                                >
                                    Отмена
                                </button>
                            )}
                            <button
                                className={`flex h-6 w-[120px] rounded-[10px] text-xs justify-center items-center text-[#181818] dark:text-[#FFFFFF] bg-[#83d2b7] hover:bg-[#8ce5c6] dark:bg-[#187A33] dark:hover:bg-[#1D9A40] shadow-md shadow-[#18181830]`}
                                onClick={() => {
                                    if (
                                        isUserRoleName == 'initiator' ||
                                        isUserRoleName == 'curator'
                                    ) {
                                        handleFileUploadInitiator()
                                    } else {
                                        handleFileUpload()
                                    }
                                }}
                                disabled={isImporting ? true : false}
                            >
                                {isImporting ? (
                                    <svg
                                        className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        ></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                        ></path>
                                    </svg>
                                ) : (
                                    'Импортировать'
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {copyPlanPositionPopup && (
                <div
                    className="fixed top-0 left-0 w-full h-full bg-[#000000] bg-opacity-50 flex justify-center items-center"
                    onClick={handleCopyPlanPositionPopup}
                >
                    <div
                        className="p-5 rounded-lg bg-[#e5e5e5] dark:bg-[#262427] w-[600px] max-h-[600px]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex flex-row w-full items-center justify-stsrt gap-2">
                            <svg
                                className="w-5 h-5"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                id="times-circle"
                            >
                                <path
                                    fill="#FFBF00"
                                    d="M12,14a1.25,1.25,0,1,0,1.25,1.25A1.25,1.25,0,0,0,12,14Zm0-1.5a1,1,0,0,0,1-1v-3a1,1,0,0,0-2,0v3A1,1,0,0,0,12,12.5ZM12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Z"
                                ></path>
                            </svg>
                            <h2 className="text-[#181818] dark:text-[#FFFFFF] text-[18px]">
                                Копирование позиции плана закупки
                            </h2>
                        </div>
                        <div className="flex flex-col mt-2 space-y-1">
                            <label className="text-[14px] text-[#181818] dark:text-[#FFFFFF]">
                                Вы уверены, что хотите копировать следующие
                                позиции плана закупки? Продолжить?
                            </label>
                            <div className="flex flex-row w-full space-x-5 pt-2">
                                <div className="flex flex-col w-full">
                                    {/* name */}
                                    <div className="flex flex-row gap-1 px-1 py-2 rounded-t-lg text-[10px] text-[#6A6A6A] dark:text-[#8A8A8A] bg-[#d2d5d8] dark:bg-[#333033]">
                                        <div className="flex w-10 items-center justify-center text-center">
                                            №
                                        </div>
                                        <div className="flex w-10 items-center justify-center text-center">
                                            № в ЕИС
                                        </div>
                                        <div className="flex flex-1 items-center justify-center text-center">
                                            Предмет договора
                                        </div>
                                        <div className="flex w-28 items-center justify-center text-center">
                                            НМЦД
                                        </div>
                                        <div className="flex w-6 items-center justify-center"></div>
                                    </div>
                                    {/* data */}
                                    <div className="flex flex-col h-[200px] gap-1 py-1 px-1 grow bg-[#e4e6e8] dark:bg-[#1D1C1E] rounded-b-lg overflow-y-auto custom-scrollbar">
                                        <div className="flex flex-col w-full space-y-1">
                                            {copyItems.map((item, index) => (
                                                <div
                                                    key={item.guid}
                                                    className="flex flex-row rounded text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] hover:bg-[#FFFFFF] dark:bg-[#2A282B] dark:hover:bg-[#373538]"
                                                >
                                                    <div className="flex flex-row w-full">
                                                        <div className="flex flex-row flex-1 min-h-8 gap-1 text-[#181818] dark:text-[#FFFFFF] text-[11px]">
                                                            <div className="flex w-10 items-center justify-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                                                                {index + 1}
                                                            </div>
                                                            <div className="flex w-10 items-center justify-center">
                                                                {item.ordinal_number
                                                                    ? item.ordinal_number
                                                                    : '-'}
                                                            </div>
                                                            <div className="flex  flex-1 items-center justify-left p-1">
                                                                {item.contract_subject ? (
                                                                    <span className="fourrow">
                                                                        {
                                                                            item.contract_subject
                                                                        }
                                                                    </span>
                                                                ) : (
                                                                    '-'
                                                                )}
                                                            </div>
                                                            <div className="flex w-24 items-center justify-end">
                                                                <HoverTooltip
                                                                    tooltipText={
                                                                        item.currency_digital_code
                                                                            ? String(
                                                                                  currencyList.find(
                                                                                      (
                                                                                          c
                                                                                      ) =>
                                                                                          c.num_code ===
                                                                                          String(
                                                                                              item.currency_digital_code
                                                                                          )
                                                                                  )
                                                                                      ?.name
                                                                              )
                                                                            : '-'
                                                                    }
                                                                >
                                                                    <span>
                                                                        {Number(
                                                                            item.maximum_contract_price
                                                                        ).toLocaleString(
                                                                            'ru-RU',
                                                                            {
                                                                                minimumFractionDigits: 2,
                                                                            }
                                                                        )}{' '}
                                                                        {item.currency_digital_code
                                                                            ? item.currency_digital_code ==
                                                                              643
                                                                                ? ''
                                                                                : currencyList.find(
                                                                                      (
                                                                                          c
                                                                                      ) =>
                                                                                          c.num_code ===
                                                                                          String(
                                                                                              item.currency_digital_code
                                                                                          )
                                                                                  )
                                                                                      ?.char_sign ||
                                                                                  '?'
                                                                            : ''}
                                                                    </span>
                                                                </HoverTooltip>
                                                            </div>
                                                            <div className="flex w-8 items-center justify-center text-[#6A6A6A] dark:text-[#8A8A8A] ">
                                                                <button
                                                                    onClick={() =>
                                                                        handleCopyItem(
                                                                            item.guid
                                                                        )
                                                                    }
                                                                    className=" flex w-6 h-6 rounded-full items-center justify-center hover:bg-[#ed9cae] dark:hover:bg-[#701F1F]"
                                                                >
                                                                    <svg
                                                                        className="w-3 h-3"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        viewBox="0 0 24 24"
                                                                        id="trash-alt"
                                                                    >
                                                                        <path
                                                                            fill={
                                                                                theme ==
                                                                                'dark'
                                                                                    ? '#FFFFFF'
                                                                                    : '#181818'
                                                                            }
                                                                            d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"
                                                                        ></path>
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-row mt-5 text-right justify-end">
                            {isCopying ? (
                                ''
                            ) : (
                                <button
                                    className="flex flex-row min-w-[120px] h-6 px-4 rounded-[10px] justify-center items-center gap-2 text-xs shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] dark:bg-[#494849] hover:bg-[#FFFFFF] dark:hover:bg-[#656365]"
                                    onClick={handleCopyPlanPositionPopup}
                                >
                                    Отмена
                                </button>
                            )}
                            <button
                                className={`flex px-4 py-1 min-w-[120px] h-6 ml-2 justify-center items-center rounded-[10px] shadow-md shadow-[#18181830] text-xs text-[#181818] dark:text-[#FFFFFF] bg-[#83d2b7] hover:bg-[#8ce5c6] dark:bg-[#187A33] dark:hover:bg-[#1D9A40]`}
                                onClick={handleCopyClick}
                                disabled={isCopying ? true : false}
                            >
                                {isCopying ? (
                                    <svg
                                        className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        ></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                        ></path>
                                    </svg>
                                ) : (
                                    'Копировать'
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {annulatePlanPositionPopup && (
                <div
                    className="fixed top-0 left-0 w-full h-full bg-[#000000] bg-opacity-50 flex justify-center items-center"
                    onClick={handleAnnulatePlanPositionPopup}
                >
                    <div
                        className="p-5 rounded-lg bg-[#e5e5e5] dark:bg-[#262427] w-[600px] max-h-[600px]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex flex-row w-full items-center justify-stsrt gap-2">
                            <svg
                                className="w-5 h-5"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                id="times-circle"
                            >
                                <path
                                    fill="#C15C5C"
                                    d="M15.71,8.29a1,1,0,0,0-1.42,0L12,10.59,9.71,8.29A1,1,0,0,0,8.29,9.71L10.59,12l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l2.29,2.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L13.41,12l2.3-2.29A1,1,0,0,0,15.71,8.29Zm3.36-3.36A10,10,0,1,0,4.93,19.07,10,10,0,1,0,19.07,4.93ZM17.66,17.66A8,8,0,1,1,20,12,7.95,7.95,0,0,1,17.66,17.66Z"
                                ></path>
                            </svg>
                            <h2 className="text-[#181818] dark:text-[#FFFFFF] text-[18px]">
                                Аннулирование позиции плана закупки
                            </h2>
                        </div>
                        <div className="flex flex-col mt-2 space-y-1">
                            <label className="text-[14px] text-[#181818] dark:text-[#FFFFFF]">
                                Позиции плана закупки размещены в ЕИС. Вы
                                уверены, что хотите аннулировать данные позиции
                                плана закупки? Это действие является
                                необратимым. Продолжить?
                            </label>
                            <div className="flex flex-col">
                                <label className="flex mb-1 text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                    Обоснование аннулирования позиций
                                </label>
                                <select
                                    className="form-select flex p-2 rounded-md border-0 text-sm focus:outline-none focus:ring-1 focus:ring-[#181818] dark:focus:ring-[#FFFFFF]"
                                    value={annulateReason}
                                    onChange={(e) =>
                                        handleAnnulateReasonChange(
                                            e.target.value
                                        )
                                    }
                                >
                                    <option value="REJECT">
                                        Отказ от проведения закупки
                                    </option>
                                    <option value="INVALID">
                                        Признание торгов недействительными
                                    </option>
                                    <option value="NOT_PERFORMED">
                                        Торги не состоялись
                                    </option>
                                </select>
                            </div>
                            <div className="flex flex-row w-full space-x-5 pt-2">
                                <div className="flex flex-col w-full">
                                    {/* name */}
                                    <div className="flex flex-row gap-1 px-1 py-2 rounded-t-lg text-[10px] text-[#6A6A6A] dark:text-[#8A8A8A] bg-[#d2d5d8] dark:bg-[#333033]">
                                        <div className="flex w-10 items-center justify-center text-center">
                                            №
                                        </div>
                                        <div className="flex w-10 items-center justify-center text-center">
                                            № в ЕИС
                                        </div>
                                        <div className="flex flex-1 items-center justify-center text-center">
                                            Предмет договора
                                        </div>
                                        <div className="flex w-28 items-center justify-center text-center">
                                            НМЦД
                                        </div>
                                        <div className="flex w-6 items-center justify-center"></div>
                                    </div>
                                    {/* data */}
                                    <div className="flex flex-col h-[200px] gap-1 py-1 px-1 grow bg-[#e4e6e8] dark:bg-[#1D1C1E] rounded-b-lg overflow-y-auto custom-scrollbar">
                                        <div className="flex flex-col w-full space-y-1">
                                            {annulateItems.map(
                                                (item, index) => (
                                                    <div
                                                        key={item.guid}
                                                        className="flex flex-row rounded text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] hover:bg-[#FFFFFF] dark:bg-[#2A282B] dark:hover:bg-[#373538]"
                                                    >
                                                        <div className="flex flex-row w-full">
                                                            <div className="flex flex-row flex-1 min-h-8 gap-1 text-[#181818] dark:text-[#FFFFFF] text-[11px]">
                                                                <div className="flex w-10 items-center justify-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                                                                    {index + 1}
                                                                </div>
                                                                <div className="flex w-10 items-center justify-center">
                                                                    {item.ordinal_number
                                                                        ? item.ordinal_number
                                                                        : '-'}
                                                                </div>
                                                                <div className="flex  flex-1 items-center justify-left p-1">
                                                                    {item.contract_subject ? (
                                                                        <span className="fourrow">
                                                                            {
                                                                                item.contract_subject
                                                                            }
                                                                        </span>
                                                                    ) : (
                                                                        '-'
                                                                    )}
                                                                </div>
                                                                <div className="flex w-24 items-center justify-end">
                                                                    <HoverTooltip
                                                                        tooltipText={
                                                                            item.currency_digital_code
                                                                                ? String(
                                                                                      currencyList.find(
                                                                                          (
                                                                                              c
                                                                                          ) =>
                                                                                              c.num_code ===
                                                                                              String(
                                                                                                  item.currency_digital_code
                                                                                              )
                                                                                      )
                                                                                          ?.name
                                                                                  )
                                                                                : '-'
                                                                        }
                                                                    >
                                                                        <span>
                                                                            {Number(
                                                                                item.maximum_contract_price
                                                                            ).toLocaleString(
                                                                                'ru-RU',
                                                                                {
                                                                                    minimumFractionDigits: 2,
                                                                                }
                                                                            )}{' '}
                                                                            {item.currency_digital_code
                                                                                ? item.currency_digital_code ==
                                                                                  643
                                                                                    ? ''
                                                                                    : currencyList.find(
                                                                                          (
                                                                                              c
                                                                                          ) =>
                                                                                              c.num_code ===
                                                                                              String(
                                                                                                  item.currency_digital_code
                                                                                              )
                                                                                      )
                                                                                          ?.char_sign ||
                                                                                      '?'
                                                                                : ''}
                                                                        </span>
                                                                    </HoverTooltip>
                                                                </div>
                                                                <div className="flex w-8 items-center justify-center text-[#6A6A6A] dark:text-[#8A8A8A] ">
                                                                    <button
                                                                        onClick={() =>
                                                                            handleAnnulateItem(
                                                                                item.guid
                                                                            )
                                                                        }
                                                                        className=" flex w-6 h-6 rounded-full items-center justify-center hover:bg-[#ed9cae] dark:hover:bg-[#701F1F]"
                                                                    >
                                                                        <svg
                                                                            className="w-3 h-3"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            viewBox="0 0 24 24"
                                                                            id="trash-alt"
                                                                        >
                                                                            <path
                                                                                fill={
                                                                                    theme ==
                                                                                    'dark'
                                                                                        ? '#FFFFFF'
                                                                                        : '#181818'
                                                                                }
                                                                                d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"
                                                                            ></path>
                                                                        </svg>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-row mt-5 text-right justify-end gap-2">
                            <button
                                className={`flex px-4 py-1 min-w-[120px] h-6 rounded-[10px] shadow-md shadow-[#18181830] text-xs text-[#181818] dark:text-[#FFFFFF] ml-2 items-center justify-center bg-[#ed9cae] hover:bg-[#ffa7ba] dark:bg-[#701F1F] dark:hover:bg-[#9e2c2c]`}
                                onClick={() =>
                                    handleAnnulateClick(annulateReason)
                                } // Вызвать handle
                                disabled={isAnnulating ? true : false}
                            >
                                {isAnnulating ? (
                                    <svg
                                        className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        ></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                        ></path>
                                    </svg>
                                ) : (
                                    'Аннулировать'
                                )}
                            </button>
                            {isAnnulating ? (
                                ''
                            ) : (
                                <button
                                    className="flex flex-row min-w-[120px] h-6 px-4 rounded-[10px] justify-center items-center gap-2 text-xs shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] dark:bg-[#494849] hover:bg-[#FFFFFF] dark:hover:bg-[#656365]"
                                    onClick={handleAnnulatePlanPositionPopup}
                                >
                                    Отмена
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {copyPlanPositionDraftPopup && (
                <div
                    className="fixed top-0 left-0 w-full h-full bg-[#000000] bg-opacity-50 flex justify-center items-center"
                    onClick={handleCopyPlanPositionDraftPopup}
                >
                    <div
                        className="p-5 rounded-lg bg-[#e5e5e5] dark:bg-[#262427] w-[600px] max-h-[600px]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex flex-row w-full items-center justify-stsrt gap-2">
                            <svg
                                className="w-5 h-5"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                id="times-circle"
                            >
                                <path
                                    fill="#FFBF00"
                                    d="M12,14a1.25,1.25,0,1,0,1.25,1.25A1.25,1.25,0,0,0,12,14Zm0-1.5a1,1,0,0,0,1-1v-3a1,1,0,0,0-2,0v3A1,1,0,0,0,12,12.5ZM12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Z"
                                ></path>
                            </svg>
                            <h2 className="text-[#181818] dark:text-[#FFFFFF] text-[18px]">
                                Копирование позиции плана закупки
                            </h2>
                        </div>
                        <div className="flex flex-col mt-2 space-y-1">
                            <label className="text-[14px] text-[#181818] dark:text-[#FFFFFF]">
                                Вы уверены, что хотите копировать следующие
                                позиции плана закупки? Продолжить?
                            </label>
                            <div className="flex flex-row w-full space-x-5 pt-2">
                                <div className="flex flex-col w-full">
                                    {/* name */}
                                    <div className="flex flex-row gap-1 px-1 py-2 rounded-t-lg text-[10px] text-[#6A6A6A] dark:text-[#8A8A8A] bg-[#d2d5d8] dark:bg-[#333033]">
                                        <div className="flex w-10 items-center justify-center text-center">
                                            №
                                        </div>
                                        <div className="flex w-10 items-center justify-center text-center">
                                            № в ЕИС
                                        </div>
                                        <div className="flex flex-1 items-center justify-center text-center">
                                            Предмет договора
                                        </div>
                                        <div className="flex w-28 items-center justify-center text-center">
                                            НМЦД
                                        </div>
                                        <div className="flex w-6 items-center justify-center"></div>
                                    </div>
                                    {/* data */}
                                    <div className="flex flex-col h-[200px] gap-1 py-1 px-1 grow bg-[#e4e6e8] dark:bg-[#1D1C1E] rounded-b-lg overflow-y-auto custom-scrollbar">
                                        <div className="flex flex-col w-full space-y-1">
                                            {copyItems.map((item, index) => (
                                                <div
                                                    key={item.guid}
                                                    className="flex flex-row rounded text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] hover:bg-[#FFFFFF] dark:bg-[#2A282B] dark:hover:bg-[#373538]"
                                                >
                                                    <div className="flex flex-row w-full">
                                                        <div className="flex flex-row flex-1 min-h-8 gap-1 text-[#181818] dark:text-[#FFFFFF] text-[11px]">
                                                            <div className="flex w-10 items-center justify-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                                                                {index + 1}
                                                            </div>
                                                            <div className="flex w-10 items-center justify-center">
                                                                {item.ordinal_number
                                                                    ? item.ordinal_number
                                                                    : '-'}
                                                            </div>
                                                            <div className="flex  flex-1 items-center justify-left p-1">
                                                                {item.contract_subject ? (
                                                                    <span className="fourrow">
                                                                        {
                                                                            item.contract_subject
                                                                        }
                                                                    </span>
                                                                ) : (
                                                                    '-'
                                                                )}
                                                            </div>
                                                            <div className="flex w-24 items-center justify-end">
                                                                <HoverTooltip
                                                                    tooltipText={
                                                                        item.currency_digital_code
                                                                            ? String(
                                                                                  currencyList.find(
                                                                                      (
                                                                                          c
                                                                                      ) =>
                                                                                          c.num_code ===
                                                                                          String(
                                                                                              item.currency_digital_code
                                                                                          )
                                                                                  )
                                                                                      ?.name
                                                                              )
                                                                            : '-'
                                                                    }
                                                                >
                                                                    <span>
                                                                        {Number(
                                                                            item.maximum_contract_price
                                                                        ).toLocaleString(
                                                                            'ru-RU',
                                                                            {
                                                                                minimumFractionDigits: 2,
                                                                            }
                                                                        )}{' '}
                                                                        {item.currency_digital_code
                                                                            ? item.currency_digital_code ==
                                                                              643
                                                                                ? ''
                                                                                : currencyList.find(
                                                                                      (
                                                                                          c
                                                                                      ) =>
                                                                                          c.num_code ===
                                                                                          String(
                                                                                              item.currency_digital_code
                                                                                          )
                                                                                  )
                                                                                      ?.char_sign ||
                                                                                  '?'
                                                                            : ''}
                                                                    </span>
                                                                </HoverTooltip>
                                                            </div>
                                                            <div className="flex w-8 items-center justify-center text-[#6A6A6A] dark:text-[#8A8A8A] ">
                                                                <button
                                                                    onClick={() =>
                                                                        handleCopyDraftItem(
                                                                            item.guid
                                                                        )
                                                                    }
                                                                    className=" flex w-6 h-6 rounded-full items-center justify-center hover:bg-[#ed9cae] dark:hover:bg-[#701F1F]"
                                                                >
                                                                    <svg
                                                                        className="w-3 h-3"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        viewBox="0 0 24 24"
                                                                        id="trash-alt"
                                                                    >
                                                                        <path
                                                                            fill={
                                                                                theme ==
                                                                                'dark'
                                                                                    ? '#FFFFFF'
                                                                                    : '#181818'
                                                                            }
                                                                            d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"
                                                                        ></path>
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-row mt-5 text-right justify-end">
                            {isCopying ? (
                                ''
                            ) : (
                                <button
                                    className="flex flex-row min-w-[120px] h-6 px-4 rounded-[10px] justify-center items-center gap-2 text-xs shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] dark:bg-[#494849] hover:bg-[#FFFFFF] dark:hover:bg-[#656365]"
                                    onClick={handleCopyPlanPositionDraftPopup}
                                >
                                    Отмена
                                </button>
                            )}
                            <button
                                className={`flex px-4 py-1 min-w-[120px] h-6 ml-2 justify-center items-center rounded-[10px] shadow-md shadow-[#18181830] text-xs text-[#181818] dark:text-[#FFFFFF] bg-[#83d2b7] hover:bg-[#8ce5c6] dark:bg-[#187A33] dark:hover:bg-[#1D9A40]`}
                                onClick={handleCopyDraftClick} // Вызвать handleCopy
                                disabled={isCopying ? true : false}
                            >
                                {isCopying ? (
                                    <svg
                                        className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        ></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                        ></path>
                                    </svg>
                                ) : (
                                    'Копировать'
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {statusChangePlanPositionPopup && (
                <div
                    className="fixed top-0 left-0 w-full h-full bg-[#000000] bg-opacity-50 flex justify-center items-center"
                    onClick={() => handleStatusChangePlanPositionPopup('')}
                >
                    <div
                        className="p-5 rounded-lg bg-[#e5e5e5] dark:bg-[#262427] w-[600px] max-h-[600px]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex flex-row w-full items-center justify-stsrt gap-2">
                            <svg
                                className="w-5 h-5"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                id="times-circle"
                            >
                                <path
                                    fill="#FFBF00"
                                    d="M12,14a1.25,1.25,0,1,0,1.25,1.25A1.25,1.25,0,0,0,12,14Zm0-1.5a1,1,0,0,0,1-1v-3a1,1,0,0,0-2,0v3A1,1,0,0,0,12,12.5ZM12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Z"
                                ></path>
                            </svg>
                            <h2 className="text-[#181818] dark:text-[#FFFFFF] text-[18px]">
                                Подготовка к размещению
                            </h2>
                        </div>
                        <div className="flex flex-col mt-2 space-y-1">
                            <label className="text-[14px] text-[#181818] dark:text-[#FFFFFF]">
                                Вы уверены, что хотите направить следующие
                                позиции плана закупки на стадию «
                                {statusChangeFlag}»?
                            </label>
                            <div className="flex flex-row w-full space-x-5 pt-2">
                                <div className="flex flex-col w-full">
                                    {/* name */}
                                    <div className="flex flex-row gap-1 px-1 py-2 rounded-t-lg text-[10px] text-[#6A6A6A] dark:text-[#8A8A8A] bg-[#d2d5d8] dark:bg-[#333033]">
                                        <div className="flex w-10 items-center justify-center text-center">
                                            №
                                        </div>
                                        <div className="flex w-10 items-center justify-center text-center">
                                            № в ЕИС
                                        </div>
                                        <div className="flex flex-1 items-center justify-center text-center">
                                            Предмет договора
                                        </div>
                                        <div className="flex w-28 items-center justify-center text-center">
                                            НМЦД
                                        </div>
                                        <div className="flex w-6 items-center justify-center"></div>
                                    </div>
                                    {/* data */}
                                    <div className="flex flex-col h-[200px] gap-1 py-1 px-1 grow bg-[#e4e6e8] dark:bg-[#1D1C1E] rounded-b-lg overflow-y-auto custom-scrollbar">
                                        <div className="flex flex-col w-full space-y-1">
                                            {statusChangeItems.map(
                                                (item, index) => (
                                                    <div
                                                        key={item.guid}
                                                        className="flex flex-row rounded text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] hover:bg-[#FFFFFF] dark:bg-[#2A282B] dark:hover:bg-[#373538]"
                                                    >
                                                        <div className="flex flex-row w-full">
                                                            <div className="flex flex-row flex-1 min-h-8 gap-1 text-[#181818] dark:text-[#FFFFFF] text-[11px]">
                                                                <div className="flex w-10 items-center justify-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                                                                    {index + 1}
                                                                </div>
                                                                <div className="flex w-10 items-center justify-center">
                                                                    {item.ordinal_number
                                                                        ? item.ordinal_number
                                                                        : '-'}
                                                                </div>
                                                                <div className="flex  flex-1 items-center justify-left p-1">
                                                                    {item.contract_subject ? (
                                                                        <span className="fourrow">
                                                                            {
                                                                                item.contract_subject
                                                                            }
                                                                        </span>
                                                                    ) : (
                                                                        '-'
                                                                    )}
                                                                </div>
                                                                <div className="flex w-24 items-center justify-end">
                                                                    <HoverTooltip
                                                                        tooltipText={
                                                                            item.currency_digital_code
                                                                                ? String(
                                                                                      currencyList.find(
                                                                                          (
                                                                                              c
                                                                                          ) =>
                                                                                              c.num_code ===
                                                                                              String(
                                                                                                  item.currency_digital_code
                                                                                              )
                                                                                      )
                                                                                          ?.name
                                                                                  )
                                                                                : '-'
                                                                        }
                                                                    >
                                                                        <span>
                                                                            {Number(
                                                                                item.maximum_contract_price
                                                                            ).toLocaleString(
                                                                                'ru-RU',
                                                                                {
                                                                                    minimumFractionDigits: 2,
                                                                                }
                                                                            )}{' '}
                                                                            {item.currency_digital_code
                                                                                ? item.currency_digital_code ==
                                                                                  643
                                                                                    ? ''
                                                                                    : currencyList.find(
                                                                                          (
                                                                                              c
                                                                                          ) =>
                                                                                              c.num_code ===
                                                                                              String(
                                                                                                  item.currency_digital_code
                                                                                              )
                                                                                      )
                                                                                          ?.char_sign ||
                                                                                      '?'
                                                                                : ''}
                                                                        </span>
                                                                    </HoverTooltip>
                                                                </div>
                                                                <div className="flex w-8 items-center justify-center text-[#6A6A6A] dark:text-[#8A8A8A] ">
                                                                    <button
                                                                        onClick={() =>
                                                                            handleStatusChangeItem(
                                                                                item.guid
                                                                            )
                                                                        }
                                                                        className=" flex w-6 h-6 rounded-full items-center justify-center hover:bg-[#ed9cae] dark:hover:bg-[#701F1F]"
                                                                    >
                                                                        <svg
                                                                            className="w-3 h-3"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            viewBox="0 0 24 24"
                                                                            id="trash-alt"
                                                                        >
                                                                            <path
                                                                                fill={
                                                                                    theme ==
                                                                                    'dark'
                                                                                        ? '#FFFFFF'
                                                                                        : '#181818'
                                                                                }
                                                                                d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"
                                                                            ></path>
                                                                        </svg>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-row mt-5 text-right justify-end">
                            {isStatusChanging ? (
                                ''
                            ) : (
                                <button
                                    className="px-4 py-1 min-w-[120px] h-6 rounded-full shadow-md shadow-[#18181830] text-xs text-[#181818] dark:text-[#FFFFFF] bg-[#494849] hover:bg-[#656365]"
                                    onClick={() =>
                                        handleStatusChangePlanPositionPopup('')
                                    }
                                >
                                    Отмена
                                </button>
                            )}
                            <button
                                className={`flex px-4 py-1 min-w-[120px] h-6 rounded-full shadow-md shadow-[#18181830] text-xs text-[#181818] dark:text-[#FFFFFF] ml-2 items-center justify-center bg-[#187A33] hover:bg-[#1D9A40]`}
                                onClick={handleStatusChangeClick} // Вызвать handleStatusChange
                                disabled={isStatusChanging ? true : false}
                            >
                                {isStatusChanging ? (
                                    <svg
                                        className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        ></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                        ></path>
                                    </svg>
                                ) : (
                                    'Изменить'
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {stageChangePlanPositionPopup && (
                <div
                    className="fixed top-0 left-0 w-full h-full bg-[#000000] bg-opacity-50 flex justify-center items-center"
                    onClick={() => handleStageChangePlanPositionPopup('')}
                >
                    <div
                        className="p-5 rounded-lg bg-[#e5e5e5] dark:bg-[#262427] w-[600px] max-h-[600px]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex flex-row w-full items-center justify-stsrt gap-2">
                            <svg
                                className="w-5 h-5"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                id="times-circle"
                            >
                                <path
                                    fill="#FFBF00"
                                    d="M12,14a1.25,1.25,0,1,0,1.25,1.25A1.25,1.25,0,0,0,12,14Zm0-1.5a1,1,0,0,0,1-1v-3a1,1,0,0,0-2,0v3A1,1,0,0,0,12,12.5ZM12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Z"
                                ></path>
                            </svg>
                            <h2 className="text-[#181818] dark:text-[#FFFFFF] text-[18px]">
                                Изменение стадии
                            </h2>
                        </div>
                        <div className="flex flex-col mt-2 space-y-1">
                            <label className="text-[14px] text-[#181818] dark:text-[#FFFFFF]">
                                Вы уверены, что хотите направить следующие
                                позиции плана закупки на стадию «
                                {stageChangeFlag}»?
                            </label>
                            <div className="flex flex-row w-full space-x-5 pt-2">
                                <div className="flex flex-col w-full">
                                    {/* name */}
                                    <div className="flex flex-row gap-1 px-1 py-2 rounded-t-lg text-[10px] text-[#6A6A6A] dark:text-[#8A8A8A] bg-[#d2d5d8] dark:bg-[#333033]">
                                        <div className="flex w-10 items-center justify-center text-center">
                                            №
                                        </div>
                                        <div className="flex w-10 items-center justify-center text-center">
                                            № в ЕИС
                                        </div>
                                        <div className="flex flex-1 items-center justify-center text-center">
                                            Предмет договора
                                        </div>
                                        <div className="flex w-28 items-center justify-center text-center">
                                            НМЦД
                                        </div>
                                        <div className="flex w-6 items-center justify-center"></div>
                                    </div>
                                    {/* data */}
                                    <div className="flex flex-col h-[200px] gap-1 py-1 px-1 grow bg-[#e4e6e8] dark:bg-[#1D1C1E] rounded-b-lg overflow-y-auto custom-scrollbar">
                                        <div className="flex flex-col w-full space-y-1">
                                            {stageChangeItems.map(
                                                (item, index) => (
                                                    <div
                                                        key={item.guid}
                                                        className="flex flex-row rounded text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] hover:bg-[#FFFFFF] dark:bg-[#2A282B] dark:hover:bg-[#373538]"
                                                    >
                                                        <div className="flex flex-row w-full">
                                                            <div className="flex flex-row flex-1 min-h-8 gap-1 text-[#181818] dark:text-[#FFFFFF] text-[11px]">
                                                                <div className="flex w-10 items-center justify-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                                                                    {index + 1}
                                                                </div>
                                                                <div className="flex w-10 items-center justify-center">
                                                                    {item.ordinal_number
                                                                        ? item.ordinal_number
                                                                        : '-'}
                                                                </div>
                                                                <div className="flex  flex-1 items-center justify-left p-1">
                                                                    {item.contract_subject ? (
                                                                        <span className="fourrow">
                                                                            {
                                                                                item.contract_subject
                                                                            }
                                                                        </span>
                                                                    ) : (
                                                                        '-'
                                                                    )}
                                                                </div>
                                                                <div className="flex w-24 items-center justify-end">
                                                                    <HoverTooltip
                                                                        tooltipText={
                                                                            item.currency_digital_code
                                                                                ? String(
                                                                                      currencyList.find(
                                                                                          (
                                                                                              c
                                                                                          ) =>
                                                                                              c.num_code ===
                                                                                              String(
                                                                                                  item.currency_digital_code
                                                                                              )
                                                                                      )
                                                                                          ?.name
                                                                                  )
                                                                                : '-'
                                                                        }
                                                                    >
                                                                        <span>
                                                                            {Number(
                                                                                item.maximum_contract_price
                                                                            ).toLocaleString(
                                                                                'ru-RU',
                                                                                {
                                                                                    minimumFractionDigits: 2,
                                                                                }
                                                                            )}{' '}
                                                                            {item.currency_digital_code
                                                                                ? item.currency_digital_code ==
                                                                                  643
                                                                                    ? ''
                                                                                    : currencyList.find(
                                                                                          (
                                                                                              c
                                                                                          ) =>
                                                                                              c.num_code ===
                                                                                              String(
                                                                                                  item.currency_digital_code
                                                                                              )
                                                                                      )
                                                                                          ?.char_sign ||
                                                                                      '?'
                                                                                : ''}
                                                                        </span>
                                                                    </HoverTooltip>
                                                                </div>
                                                                <div className="flex w-8 items-center justify-center text-[#6A6A6A] dark:text-[#8A8A8A] ">
                                                                    <button
                                                                        onClick={() =>
                                                                            handleStageChangeItem(
                                                                                item.guid
                                                                            )
                                                                        }
                                                                        className="flex w-6 h-6 rounded-full items-center justify-center hover:bg-[#ed9cae] dark:hover:bg-[#701F1F]"
                                                                    >
                                                                        <svg
                                                                            className="w-3 h-3"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            viewBox="0 0 24 24"
                                                                            id="trash-alt"
                                                                        >
                                                                            <path
                                                                                fill={
                                                                                    theme ==
                                                                                    'dark'
                                                                                        ? '#FFFFFF'
                                                                                        : '#181818'
                                                                                }
                                                                                d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"
                                                                            ></path>
                                                                        </svg>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-row mt-5 text-right justify-end">
                            {isStageChanging ? (
                                ''
                            ) : (
                                <button
                                    className="flex flex-row min-w-[120px] h-6 px-4 rounded-[10px] justify-center items-center gap-2 text-xs shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] dark:bg-[#494849] hover:bg-[#FFFFFF] dark:hover:bg-[#656365]"
                                    onClick={() =>
                                        handleStageChangePlanPositionPopup('')
                                    }
                                >
                                    Отмена
                                </button>
                            )}
                            <button
                                className={`flex px-4 py-1 min-w-[120px] h-6 ml-2 justify-center items-center rounded-[10px] shadow-md shadow-[#18181830] text-xs text-[#181818] dark:text-[#FFFFFF] bg-[#83d2b7] hover:bg-[#8ce5c6] dark:bg-[#187A33] dark:hover:bg-[#1D9A40]`}
                                onClick={handleStageChangeClick} // Вызвать handleStageChange
                                disabled={isStageChanging ? true : false}
                            >
                                {isStageChanging ? (
                                    <svg
                                        className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        ></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                        ></path>
                                    </svg>
                                ) : (
                                    'Изменить'
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {toEisSendPopup && (
                <div
                    className="fixed top-0 left-0 w-full h-full bg-[#000000] bg-opacity-50 flex justify-center items-center"
                    onClick={handleToEisSendPopup}
                >
                    <div
                        className="p-5 rounded-lg bg-[#e5e5e5] dark:bg-[#262427] w-[600px] h-fit"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex flex-row w-full items-center justify-stsrt gap-2">
                            <svg
                                className="w-5 h-5"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                id="times-circle"
                            >
                                <path
                                    fill="#FFBF00"
                                    d="M12,14a1.25,1.25,0,1,0,1.25,1.25A1.25,1.25,0,0,0,12,14Zm0-1.5a1,1,0,0,0,1-1v-3a1,1,0,0,0-2,0v3A1,1,0,0,0,12,12.5ZM12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Z"
                                ></path>
                            </svg>
                            <h2 className="text-[#181818] dark:text-[#FFFFFF] text-[18px]">
                                Отправка позиций в ЕИС
                            </h2>
                        </div>
                        <div className="flex flex-col mt-2 space-y-1">
                            <div className="flex flex-col w-full space-y-1">
                                <div>
                                    <label className="text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                                        Дата утверждения плана
                                    </label>
                                </div>
                                <div className="flex w-full space-x-5 ">
                                    <div className="flex flex-1 w-full ">
                                        <input
                                            type="date"
                                            style={{
                                                colorScheme:
                                                    theme == 'dark'
                                                        ? 'dark'
                                                        : 'light',
                                            }}
                                            className="form-input min-w-[200px] focus:outline-none focus:ring-1 focus:ring-[#181818] dark:focus:ring-[#FFFFFF]"
                                            name="approve_date"
                                            value={toEisSendInfo.approve_date}
                                            onChange={(e) =>
                                                handleInputChange(
                                                    'approve_date',
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </div>
                                    <div className="flex flex-1 w-full"></div>
                                    <div className="flex flex-1 w-full"></div>
                                </div>
                            </div>
                            <div className="flex flex-col w-full space-y-1">
                                <div>
                                    <label className="text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                                        Причина внесения изменений
                                    </label>
                                </div>
                                <div>
                                    <input
                                        className="form-input focus:outline-none focus:ring-1 focus:ring-[#181818] dark:focus:ring-[#FFFFFF] w-full"
                                        name="modification_description"
                                        value={
                                            toEisSendInfo.modification_description
                                        }
                                        onChange={(e) =>
                                            handleInputChange(
                                                'modification_description',
                                                e.target.value
                                            )
                                        }
                                        placeholder="Указать"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col w-full space-y-1">
                                <div>
                                    <label className="text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                                        Дополнительная информация
                                    </label>
                                </div>
                                <div>
                                    <input
                                        className="form-input focus:outline-none focus:ring-1 focus:ring-[#181818] dark:focus:ring-[#FFFFFF] w-full"
                                        name="additional_info"
                                        value={toEisSendInfo.additional_info}
                                        onChange={(e) =>
                                            handleInputChange(
                                                'additional_info',
                                                e.target.value
                                            )
                                        }
                                        placeholder="Указать"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col mt-3 space-y-1 w-fit items-center justify-start">
                            <Checkbox
                                label="Прикрепить файл"
                                checked={isAttachment}
                                onChange={() => setAttachment(!isAttachment)}
                                disabled={false}
                            />
                        </div>

                        <div className="flex flex-col mt-3 space-y-1 w-full items-center justify-start">
                            <FileUploaderBlock
                                planRegNumber={String(reg_number)}
                                isAttachment={isAttachment}
                                theme={theme}
                            />
                            <ToastContainer
                                position="top-right"
                                autoClose={3000}
                                hideProgressBar
                                newestOnTop
                                closeOnClick
                                draggable
                                pauseOnHover
                                theme={theme == 'dark' ? 'dark' : 'light'}
                                transition={Slide}
                                className="!z-[9999]"
                                toastClassName={() =>
                                    'flex w-fit min-h-[40px] px-3 py-2 items-center gap-2 bg-[#f6f6f6] dark:bg-[#2A282B] rounded-xl shadow-xl text-[#181818] dark:text-[#FFFFFF] text-[13px] my-1'
                                }
                            />
                        </div>

                        <div className="flex flex-row mt-5 text-right justify-end">
                            {isToEisSending ? (
                                ''
                            ) : (
                                <button
                                    className="flex flex-row min-w-[120px] h-6 px-4 rounded-[10px] justify-center items-center gap-2 text-xs shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] dark:bg-[#494849] hover:bg-[#FFFFFF] dark:hover:bg-[#656365]"
                                    onClick={handleToEisSendPopup}
                                >
                                    Отмена
                                </button>
                            )}
                            <button
                                className={`flex px-4 py-1 min-w-[120px] h-6 rounded-[10px] text-xs ml-2 items-center justify-center ${
                                    toEisSendInfo?.additional_info == '' ||
                                    toEisSendInfo?.modification_description ==
                                        ''
                                        ? 'text-[#6A6A6A] dark:text-[#8A8A8A] bg-[#d8dadc] dark:bg-[#494849] cursor-not-allowed'
                                        : 'shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#83d2b7] hover:bg-[#8ce5c6] dark:bg-[#187A33] dark:hover:bg-[#1D9A40]'
                                } `}
                                onClick={handleToEisSendClick} // Вызвать handleStageChange
                                disabled={
                                    isToEisSending
                                        ? true
                                        : toEisSendInfo?.additional_info ==
                                              '' ||
                                          toEisSendInfo?.modification_description ==
                                              ''
                                }
                            >
                                {isToEisSending ? (
                                    <svg
                                        className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        ></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                        ></path>
                                    </svg>
                                ) : (
                                    'Отправить'
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {updateFromEisPopup && (
                <div
                    className="fixed top-0 left-0 w-full h-full bg-[#000000] bg-opacity-50 flex justify-center items-center"
                    onClick={handleUpdateFromEisPopup}
                >
                    <div
                        className="p-5 rounded-lg bg-[#e5e5e5] dark:bg-[#262427] w-[450px] max-h-[600px]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex flex-row gap-2 items-center justify-start">
                            <svg
                                id="info-circle"
                                className="w-5 h-5"
                                data-name="Layer 1"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    fill="#FFBF00"
                                    d="M12,14a1.25,1.25,0,1,0,1.25,1.25A1.25,1.25,0,0,0,12,14Zm0-1.5a1,1,0,0,0,1-1v-3a1,1,0,0,0-2,0v3A1,1,0,0,0,12,12.5ZM12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Z"
                                ></path>
                            </svg>
                            <h2 className="text-[#181818] dark:text-[#FFFFFF]">
                                Обновление плана закупки
                            </h2>
                        </div>
                        <div className="flex flex-col mt-2 space-y-1">
                            <div className="flex flex-row gap-2 items-center justify-start">
                                <label className="text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                    {popupMessage}
                                </label>
                            </div>
                        </div>
                        <div className="flex flex-row mt-5 text-right justify-end">
                            {isUpdatingFromEis ? (
                                ''
                            ) : (
                                <button
                                    className="flex flex-row min-w-[120px] h-6 px-4 rounded-[10px] justify-center items-center gap-2 text-xs shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] dark:bg-[#494849] hover:bg-[#FFFFFF] dark:hover:bg-[#656365]"
                                    onClick={handleUpdateFromEisPopup}
                                >
                                    Отмена
                                </button>
                            )}
                            <button
                                className={`flex px-4 py-1 min-w-[120px] h-6 rounded-[10px] shadow-md shadow-[#18181830] text-xs text-[#181818] dark:text-[#FFFFFF] ml-2 items-center justify-center ${!isUpdatingFromEis ? 'bg-[#83d2b7] hover:bg-[#8ce5c6] dark:bg-[#187A33] dark:hover:bg-[#1D9A40]' : 'bg-[#f6f6f6] dark:bg-[#494849]'} `}
                                onClick={() => handleForceUpdate()} // Вызвать handleForceUpdate
                                disabled={isUpdatingFromEis ? true : false}
                            >
                                {isUpdatingFromEis ? (
                                    <svg
                                        className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        ></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                        ></path>
                                    </svg>
                                ) : (
                                    'Обновить'
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {toEisSendResponsePopup && (
                <div
                    className="fixed top-0 left-0 w-full h-full bg-[#000000] bg-opacity-50 flex justify-center items-center"
                    onClick={handleToEisSendResponsePopup}
                >
                    <div
                        className={`p-5 rounded-lg bg-[#e5e5e5] dark:bg-[#262427] ${
                            toEisSendResponse == 'Всё прошло успешно'
                                ? 'w-[600px]'
                                : 'w-[600px]'
                        }  h-fit`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex flex-row w-full items-center justify-stsrt gap-2">
                            {toEisSendResponse == 'Всё прошло успешно' ? (
                                <svg
                                    className="w-5 h-5"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="times-circle"
                                >
                                    <path
                                        fill="#187A33"
                                        d="M14.72,8.79l-4.29,4.3L8.78,11.44a1,1,0,1,0-1.41,1.41l2.35,2.36a1,1,0,0,0,.71.29,1,1,0,0,0,.7-.29l5-5a1,1,0,0,0,0-1.42A1,1,0,0,0,14.72,8.79ZM12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
                                    ></path>
                                </svg>
                            ) : (
                                <svg
                                    className="w-5 h-5"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="times-circle"
                                >
                                    <path
                                        fill="#C15C5C"
                                        d="M15.71,8.29a1,1,0,0,0-1.42,0L12,10.59,9.71,8.29A1,1,0,0,0,8.29,9.71L10.59,12l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l2.29,2.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L13.41,12l2.3-2.29A1,1,0,0,0,15.71,8.29Zm3.36-3.36A10,10,0,1,0,4.93,19.07,10,10,0,1,0,19.07,4.93ZM17.66,17.66A8,8,0,1,1,20,12,7.95,7.95,0,0,1,17.66,17.66Z"
                                    ></path>
                                </svg>
                            )}

                            <h2 className="text-[#181818] dark:text-[#FFFFFF] text-[18px]">
                                {toEisSendResponse == 'Всё прошло успешно'
                                    ? 'Позиции плана успешно отправлены'
                                    : 'Найдены ошибки'}
                            </h2>
                        </div>
                        <div className="flex flex-col mt-2 space-y-1">
                            {toEisSendResponse == 'Всё прошло успешно' ? (
                                <div className="flex flex-col w-full space-y-1">
                                    <div>
                                        <label className="text-[14px] text-[#181818] dark:text-[#FFFFFF]">
                                            Для дальнейшей работы разместите
                                            план закупки в ЕИС и нажмите на
                                            кнопку «Обновить план из ЕИС»
                                        </label>
                                    </div>
                                </div>
                            ) : (
                                <div className="flex flex-col w-full space-y-1 gap-2">
                                    <div className="flex flex-col mt-2 space-y-1">
                                        <label className="text-[14px] text-[#181818] dark:text-[#FFFFFF]">
                                            Внимание! Для отправки позиций плана
                                            закупки в ЕИС необходимо исправить
                                            следующие ошибки:
                                        </label>
                                    </div>
                                    <div className="flex flex-col mt-2 space-y-1">
                                        <textarea
                                            className="form-textarea flex w-full h-full text-[11px] items-start justify-start p-2 rounded-md border-0"
                                            value={toEisSendResponse}
                                            rows={21}
                                            disabled
                                            readOnly
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="flex flex-row mt-5 text-right justify-end">
                            <button
                                className="flex flex-row min-w-[120px] h-6 px-4 rounded-[10px] justify-center items-center gap-2 text-xs shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] dark:bg-[#494849] hover:bg-[#FFFFFF] dark:hover:bg-[#656365]"
                                onClick={handleToEisSendResponsePopup}
                            >
                                Закрыть
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {takeFromEisPopup && (
                <div
                    className="fixed top-0 left-0 w-full h-full bg-[#000000] bg-opacity-50 flex justify-center items-center"
                    onClick={handleTakeFromEisPopup}
                >
                    <div
                        className="p-5 rounded-lg bg-[#e5e5e5] dark:bg-[#262427] w-[450px] max-h-[400px]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h2 className="text-[#181818] dark:text-[#FFFFFF]">
                            Связывание плана
                        </h2>
                        <div className="flex flex-col mt-2 space-y-1">
                            <label className="text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                Номер плана закупки в ЕИС
                            </label>
                            <input
                                type="text"
                                className="w-full h-7 px-2 rounded-md border-0 text-sm bg-[#181818] text-[#181818] dark:text-[#FFFFFF] focus:outline-none focus:ring-1 focus:ring-[#ffffff8f]"
                                value={takePlanFromEisInfo.registration_number} // Привязка значения
                                onChange={(e) =>
                                    handleInputPlanNumberChange(
                                        'registration_number',
                                        e.target.value
                                    )
                                } // Обновление состояния
                                maxLength={10} // Ограничение на уровне HTML
                            />
                            {popupMessage != '' ? (
                                <span
                                    style={{
                                        color: '#C15C5C',
                                        fontSize: '12.8px',
                                    }}
                                >
                                    {popupMessage}
                                </span>
                            ) : (
                                ''
                            )}
                        </div>
                        <div className="flex flex-row mt-5 text-right justify-end">
                            {isTakingFromEis ? (
                                ''
                            ) : (
                                <button
                                    className="px-4 py-1 min-w-[120px] h-6 rounded-full shadow-md shadow-[#18181830] text-xs text-[#181818] dark:text-[#FFFFFF] bg-[#187A33] hover:bg-[#1D9A40]"
                                    onClick={handleTakeFromEisPopup}
                                >
                                    Отмена
                                </button>
                            )}
                            <button
                                className={`flex px-4 py-1 min-w-[120px] h-6 rounded-full shadow-md shadow-[#18181830] text-xs text-[#181818] dark:text-[#FFFFFF] ml-2 items-center justify-center ${isTakingFromEis ? 'bg-[#187A33]' : 'bg-[#494849]'} bg-[#187A33]`}
                                onClick={handleTakeFromEisClick} // Вызвать handleForceUpdate
                                disabled={isTakingFromEis ? true : false}
                            >
                                {isTakingFromEis ? (
                                    <svg
                                        className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        ></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                        ></path>
                                    </svg>
                                ) : (
                                    'Загрузить'
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Контекстное меню */}
            {menuVisible && (
                <div
                    className="absolute flex flex-col w-[200px] shadow-lg rounded-lg p-1 z-10 text-[12.8px] items-center justify-start gap-1 border border-[#b8b8b8] dark:border-[#696769] bg-[#d9dce0] dark:bg-[#333033]"
                    style={{
                        top: menuPosition.y,
                        left: menuPosition.x,
                    }}
                >
                    <TableRightClickButton
                        role={isUserRoleName}
                        stage={stage}
                        isSelect={selectedItems.length > 0}
                        isChernovik={canMoveReadyToSent}
                        isReady={canDeletePosition}
                        isCanMoveBackToEdit={canMoveBackToEdit}
                        isCanMoveReadyToEis={canMoveReadyToEis}
                        isSendPlan={isSendPlan}
                        isUpdatingFromEis={isUpdatingFromEis}
                        isAnnulate={canAnnulate}
                        multiSelect={selectedItems.length == 1}
                        theme={theme}
                        actions={{
                            add: () =>
                                navigate(
                                    `/hub/plans/${reg_number}/positions/new`
                                ),
                            ready_to_sent: () =>
                                handleStageChangePlanPositionPopup(
                                    'Подготовка к размещению'
                                ),
                            return_to_edit: () =>
                                handleStageChangePlanPositionPopup(
                                    'Редактирование'
                                ),
                            ready_to_eis: () =>
                                handleStageChangePlanPositionPopup(
                                    'Отправка в ЕИС'
                                ),
                            return_to_ready: () =>
                                handleStageChangePlanPositionPopup(
                                    'Подготовка к размещению'
                                ),
                            sent_to_eis: handleToEisSendPopup,
                            update: () => updatePlanFromEis(),
                            export_plan: handleExport,
                            copy: handleCopyPlanPositionPopup,
                            copy_draft: handleCopyPlanPositionDraftPopup,
                            delete: handleDeletePlanPositionPopup,
                            import_from_file: handleImportPlanPositionPopup,
                            print: handlePrint,
                            change: handleChangePlanPositionPopup,
                            annulate: handleAnnulatePlanPositionPopup,
                            add_contract: handleAddContractPopup,
                        }}
                        // status = {}
                        // multiSelect = {selectedItems.length > 0}
                    />
                </div>
            )}

            {uploadMessage && (
                <div
                    className="fixed top-0 left-0 w-full h-full bg-[#000000] bg-opacity-50 flex justify-center items-center"
                    onClick={() => setUploadMessage(null)}
                >
                    <div
                        className="p-5 rounded-lg bg-[#e5e5e5] dark:bg-[#262427] w-fit max-h-[600px]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex flex-col text-sm text-[#181818] dark:text-[#FFFFFF] items-center justify-center gap-5">
                            <div className="flex flex-row text-sm text-[#181818] dark:text-[#FFFFFF] items-center justify-center gap-2">
                                <div
                                    className={`flex w-5 h-5 rounded-full items-center justify-center text-[#181818] dark:text-[#FFFFFF] ${
                                        uploadMessage ==
                                        'Данные успешно импортированы.'
                                            ? 'bg-[#83d2b7] dark:bg-[#187A33]'
                                            : 'bg-[#dc742f]'
                                    }`}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        className="h-4 w-4"
                                    >
                                        <path
                                            fill={
                                                theme == 'dark'
                                                    ? '#FFFFFF'
                                                    : '#181818'
                                            }
                                            d={
                                                uploadMessage ==
                                                'Данные успешно импортированы.'
                                                    ? 'M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z'
                                                    : 'M13.41,12l4.3-4.29a1,1,0,1,0-1.42-1.42L12,10.59,7.71,6.29A1,1,0,0,0,6.29,7.71L10.59,12l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l4.29,4.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z'
                                            }
                                        ></path>
                                    </svg>
                                </div>
                                {uploadMessage}
                            </div>
                            <div className="flex w-full flex-row items-center justify-end">
                                <button
                                    className="flex gap-3 px-5 py-1 h-6 min-w-[120px] rounded-[10px] text-[12.8px] items-center justify-center shadow-md shadow-[#18181830] text-xs text-[#181818] dark:text-[#FFFFFF] bg-[#83d2b7] hover:bg-[#8ce5c6] dark:bg-[#187A33] dark:hover:bg-[#1D9A40]"
                                    onClick={() => {
                                        handleImportPlanPositionPopup
                                        setUploadMessage(null)
                                    }}
                                >
                                    ОК
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default PlanPositionListPage
